/*@license bm-permission-groups 4.2.1 SEE LICENSE IN LICENSE.txt */(function(angular) {
	'use strict';
	angular.module('bmPermissionGroup', [])
		.service('bmPermissionGroup', permissionGroup);

	permissionGroup.$inject = ['bm.permissiongroups.PermissionGroupsService'];
	function permissionGroup(permissionGroupService) {

	/*jshint validthis:true */
	var self = this;
	/* PROPS */
	function init() {
		// id (string, optional): unique id of permission group,
		self.id = '';
		// firstName (string): Permission group name
		self.name = '';
		// middleName (string) Permission group description
		self.description = '';
		// company (string, optional): permission group company id,
		self.company = '';
		// staffUsers (Array[Staff], optional): Users associated with the permission group. Currently not used.
		self.staffUsers = [];
		// filters (Array[Filter]) Filters associated with the permission group. Examples include 'Client Office', 'Confidential Client'
		self.filters = [];
	}
	self.load = function(id) {
		if(id){
			return permissionGroupService.loadPermGrp(id).then(function(resp){
				return resp;
			});
		}
	};
	self.init = init;
}
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bm.permissiongroups.PermissionGroupsDetailController', [
            'ui.router',
            'bento.wizard',
            'bluemoon.components.session',
            'bm.permissiongroups.PermissionGroupsService',
            'bm.permissiongroups.uniquePermissionGroupNameAsyncValidator',
            'nucleusPermissionsForm',
            'pascalprecht.translate'
        ])
        .controller('bm.permissiongroups.PermissionGroupsDetailController', PermissionGroupsDetailCtrl);

    PermissionGroupsDetailCtrl.$inject = [
        '$rootScope',
        '$scope',
        '$timeout',
        '$filter',
        '$state',
        '$stateParams',
        '$translate',
        '$q',
        'bmAccess',
        'bmPermission',
        'bmPermissionGroup',
        'AuthenticatedSessionData',
        'bm.permissiongroups.PermissionGroupsService',
        '$location'
    ];

    function PermissionGroupsDetailCtrl(
            $rootScope,
            $scope,
            $timeout,
            $filter,
            $state,
            $stateParams,
            $translate,
            $q,
            bmAccess,
            bmPermission,
            bmPermissionGroup,
            session,
            groupsService,
            $location) {

        /*jshint validthis:true */
        var vm = this;
        var stepsLoaded = [];
        var STEP_IDXS = { NAME: 0, PERMS: 1, MEMBERS: 2 };

        // DO NOT CHANGE - If these are changed, it could break historical pendo tracking
        var PENDO_TRACKING_STEPS = {name: 'name', functionality: 'functionality', data: 'data', members: 'members' };

        vm.updateGrpFilters = updateGrpFilters;
        vm.updateGrpMembers = updateGrpMembers;
        vm.disableMembersStep = disableMembersStep;

        vm.isSaving = false;
        vm.perms = groupsService.groupPerms;
        vm.staff = groupsService.staff;
        vm.selectedGroupId = $stateParams.groupId;
        vm.group = {};
        vm.editMode = !!vm.selectedGroupId;
        vm.granularPermsAccess = false;
        vm.membersStepDisabled = false;
        // set initial step param
        setStepForTracking('name');

        permissionAndAccess().then(function(resps) {
            vm.granularPermsAccess = resps[0] === true && resps[1] === true;
            // add Data step and load data if user has access
            if(vm.granularPermsAccess) {
                STEP_IDXS = { NAME: 0, PERMS: 1, GROUPDATA: 2, MEMBERS: 3 };
                loadGroupDataStep(vm.selectedGroupId);
            }
        });
        vm.granPermsDisabled = false;
        bmAccess.has('Platform_DisablePermissionUpdates').then(function() {
            vm.granPermsDisabled = true;
        }).catch(function(){
            vm.granPermsDisabled = false;
        });

        function loadNameStepData() {
            stepsLoaded.push(STEP_IDXS.NAME);
            if (vm.editMode) {
                groupsService.loadGroupDetail(vm.selectedGroupId).then(function(resp) {
                    vm.group = angular.extend(vm.group, resp.data,
                        // add id since service doesn't return it, and
                        // capture original name for validation purposes
                        { subjectGroupId: vm.selectedGroupId, __origName: resp.data.name });
                });
            }
        }

        function loadPermStepData() {
            stepsLoaded.push(STEP_IDXS.PERMS);
            groupsService.loadGroupPerms(vm.selectedGroupId);
        }
        function loadGroupDataStep() {
            stepsLoaded.push(STEP_IDXS.GROUPDATA);
            // get the group if a group is clicked
            if(vm.editMode) {
                vm.loadingGroupData = true;
                groupsService.loadGroupFilters(vm.selectedGroupId.toLowerCase().replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w*)/, '$1-$2-$3-$4-$5')).then(function(data){
                    vm.permissionGroup = data;
                    vm.loadingGroupData = false;
                });
            // if new, create new group with nonconfidential as default
            } else {
                vm.permissionGroup = {
                    data: {
                        company: '',
                        description: '',
                        name: '',
                        id: '',
                        filters: [{
                            filterValues: [{
                                displayName: 'all nonConfidential',
                                referenceId: '$all',
                                selected: true
                            }],
                            type: 'nonconfidential_contact'
                        }]
                    }
                };
            }
        }
        function loadMembersStepData() {
            stepsLoaded.push(STEP_IDXS.MEMBERS);
            vm.loadingGroupData = true;
            session.getBindings().then(function(data) {
                /* Hard-coded single page of 1000 items */
                groupsService.loadActiveEmployees(data.ApplicationConfiguration.CompanyId, 1000, 1).then(function(resp) {
                    var allStaff = resp.items;
                    vm.staff = [];
                    groupsService.getCompanyMain(data.ApplicationConfiguration.CompanyId).then(function(response){
                        var companyMainId = response.data.ownerContact.id;
                        groupsService.getMembers(vm.selectedGroupId).then(function(resp) {
                            vm.loadingGroupData = false;
                            var memberIdMap = [];
                            vm.members = [];
                            resp.forEach(function(item) {
                                memberIdMap[item.subjectId] = true;
                            });
                            allStaff.forEach(function(staffPerson){
                                staffPerson.__isMember = (memberIdMap[staffPerson.contactView.id] !== undefined);
                                staffPerson.department = staffPerson.hasOwnProperty('departmentNames') ? staffPerson.departmentNames.values[0] : '' ;
                                if(staffPerson.contactView.id === companyMainId) {staffPerson.isUberAdmin = true;}
                            });
                            vm.staff = allStaff;
                        }, function(){
                            // failed retrieving current group members
                            vm.loadingGroupData = false;
                        });
                    }, function(){
                        // failed retrieving companyMain
                        vm.loadingGroupData = false;
                    });
                }, function(){
                    // failed retrieving staff(employees)
                    vm.loadingGroupData = false;
                });
            }, function(){
                vm.loadingGroupData = false;
            });
        }

        // lazy load the perm details on tab switch
        $scope.$on('nucleus-permissions-form-tab-select', function(evt, node) {

            groupsService.loadGroupPermDetails(node);
        });

        vm.wizardCancel = function() {
            $state.go('setup-permission-groups');
        };

        vm.wizardDone = function() {
            if (vm.isSaving) { return; }
            $scope.$broadcast('wizardDone', {});
            vm.isSaving = true;

            var method = vm.editMode ? 'PUT' : 'POST';

            groupsService.save(method, vm.grpFilters, vm.group, vm.perms, vm.staff).then(function () {
                $state.go('setup-permission-groups');
            }, function () {
                vm.isSaving = false;
                vm.permGrpNameFormAlerts = [{
                    msg: vm.serverErrorTxt,
                    type: 'danger',
                    closeable: true
                }];
            });
        };

        // Pendo requires a unique URL for each "page" for tracking.
        // Using URL query param to meet that requirement
        function setStepForTracking(setupStep) {
            $location.search({step: setupStep});
        }

        vm.onWizardChange = function(step) {
            if (vm.permGrpNameForm.$pending) { return false; }

            if (step !== STEP_IDXS.NAME && !vm.permGrpNameForm.$valid) {
                vm.permGrpNameFormAlerts = [
                    {
                        type: 'danger',
                        msg: vm.invalidFormAlertStr,
                        closeable: true
                    }
                ];

                // Toggle ng-class to the required fields
                vm.permGrpNameForm.permGrpName.$dirty = vm.permGrpNameForm.permGrpName.$error.required || vm.permGrpNameForm.permGrpName.$error.bmUniquePermissionGroupName;
                vm.permGrpNameForm.permGrpDesc.$dirty = vm.permGrpNameForm.permGrpDesc.$error.required;
                return false;
            }
            if (step === STEP_IDXS.MEMBERS) {
                $scope.$broadcast('nextClick', {});
            }

            switch(step) {

                case STEP_IDXS.NAME:
                    setStepForTracking(PENDO_TRACKING_STEPS.name);
                    if (stepsLoaded.indexOf(STEP_IDXS.NAME) > -1) { break; }

                    loadNameStepData();
                    break;

                case STEP_IDXS.PERMS:
                    setStepForTracking(PENDO_TRACKING_STEPS.functionality);
                    if (stepsLoaded.indexOf(STEP_IDXS.PERMS) > -1) { break; }

                    loadPermStepData();
                    break;

                case STEP_IDXS.GROUPDATA:
                    setStepForTracking(PENDO_TRACKING_STEPS.data);
                    $scope.$broadcast('groupDataStep', {});
                    if (stepsLoaded.indexOf(STEP_IDXS.GROUPDATA) > -1) { break; }
                    loadGroupDataStep();
                    break;

                case STEP_IDXS.MEMBERS:
                    setStepForTracking(PENDO_TRACKING_STEPS.members);
                    if (stepsLoaded.indexOf(STEP_IDXS.MEMBERS) > -1) { break; }

                    loadMembersStepData();
                    break;
            }

            return true;
        };

        // translations for JS strings
        function translateJsStrings() {
            $translate('Bluemoon.Core.Setup.Common.InvalidForm').then(function(str) {
                vm.invalidFormAlertStr = str;
            });
            $translate('bm.session.servererror').then(function(str) {
                vm.serverErrorTxt = str;
            });
        }
        function permissionAndAccess() {
            return $q.all([bmAccess.has('Platform_GranularPermissions'), bmPermission.has('Platform.GranularPermissions')]).then(function(resps){
                return resps;
            });
        }

        function updateGrpFilters($event) {
            vm.grpFilters = $event.filters;
            vm.membersStepDisabled = $event.disableNext ? $event.disableNext : false;
        }
        function disableMembersStep($event) {
            vm.membersStepDisabled = $event.disableNext;
        }
        function updateGrpMembers($event) {
            vm.members = $event.members;
        }

        // translate promise doesn't resolve on browser refresh unless delayed till next cycle
        $timeout(translateJsStrings);
        // handle lang change
        $rootScope.$on('bmLanguageChangeSuccess', translateJsStrings);

        // trigger starting step data load
        loadNameStepData();
    }
})(window.angular);

/**
 * Permission Groups Detail Component
 */
(function(angular){
    'use strict';

    angular.module('bmPermissionGroupsDetail', ['bm-permission-groups.component.templates', 'bm.permissiongroups.PermissionGroupsDetailController'])
        .component('bmPermissionGroupsDetail', {
			templateUrl: 'components/permission-groups-detail/export/permission-groups-detail.html',
			controller: 'bm.permissiongroups.PermissionGroupsDetailController',
			controllerAs: 'vm'
        });

})(window.angular);

/**
 * Permission Groups List Component
 */
(function(angular){
    'use strict';

    angular.module('bmPermissionGroupsList', [ 'bm-permission-groups.component.templates'] )
        .component('bmPermissionGroupsList', {
			templateUrl: 'components/permission-groups-list/export/permission-groups.html',
			controller: PermissionGroupsCtrl,
			controllerAs: 'vm'
        });
	PermissionGroupsCtrl.$inject = [
        '$rootScope',
        '$scope',
        '$filter',
        '$state',
        '$timeout',
        '$uibModal',
        '$translate',
        '$q',
        '$window',
        'bm.permissiongroups.PermissionGroupsService',
        'bmAccess',
        'bmPermission'
    ];

    function PermissionGroupsCtrl(
        $rootScope,
        $scope,
        $filter,
        $state,
        $timeout,
        $uibModal,
        $translate,
        $q,
        $window,
        groupsService,
        bmAccess,
        bmPermission) {

        /*jshint validthis:true */
        var vm = this;
        vm.getHistory = getHistory;
        vm.isSystemGroup = isSystemGroup;
        vm.onHeaderCheckboxChange = onHeaderCheckboxChange;
        vm.onCheckboxChange = onCheckboxChange;
        vm.toggleEquationVisibility = toggleEquationVisibility;
        vm.selectedGroups = [];
        vm.allSelected = false;
        vm.pageState = { itemsPerPage: 25 };
        vm.filterOptions = {
            filterText: '',
            // needed so we can ignore non-displayed data in the search
            useExternalFilter: true
        };
        vm.showDeletedGroups = false;

        vm.$onChanges = function() {
            init();
        };
        vm.granPermsAccess = false;
        permissionAndAccess().then(function(resps){
            vm.granPermsAccess = resps[0] === true && resps[1] === true;
        });

        vm.granPermsDisabled = false;
        bmAccess.has('Platform_DisablePermissionUpdates').then(function() {
            vm.toolbarButtons[0].disabled = true;
            vm.toolbarButtons[1].disabled = true;
            vm.toolbarButtons[2].disabled = true;
            vm.granPermsDisabled = true;
        }).catch(function(){
            vm.granPermsDisabled = false;
        });

        function permissionAndAccess() {
            return $q.all([bmAccess.has('Platform_GranularPermissions'), bmPermission.has('Platform.GranularPermissions')]).then(function(resps){
                return resps;
            }).catch(function (error) {
                return error;
            });
        }

        // external grid filter
        $scope.$watch('vm.filterOptions.filterText', function() {
            filterGridData();
        });
        $scope.$watchCollection('vm.selectedGroups', function() {
            if (!vm.granPermsDisabled) {
                vm.toolbarButtons[2].disabled = vm.selectedGroups.length === 0;
                vm.toolbarButtons[1].disabled = vm.selectedGroups.length !== 1;
            }
        });

        function granPermsAuditAccess() {
            return bmPermission.has('Platform.GranularPermissionsAudit').then(function() {
                  vm.granPermsAuditAccess = true;
            }).catch(function(){
                  vm.granPermsAuditAccess = false;
            });
        }

        function init() {
             vm.loadingGroups = true;
             granPermsAuditAccess().then(function(){
                 groupsService.loadGroupList(vm.granPermsAuditAccess).then(function() {
                     vm.gridData = [];
                     permissionAndAccess().then(function(resps){
                         vm.granPermsAccess = resps[0] === true && resps[1] === true;
                         if(groupsService.list) {
                            groupsService.list.forEach(function(group) {
                                translateGroupEvent(group);
                                vm.gridData.push(group);
                            });
                         }
                         groupsService.list = vm.gridData;
                         vm.loadingGroups = false;
                         filterGridData();
                     });
                     vm.loadingGroups = false;
                     vm.pageState.page = 1;
                     vm.pageState.totalItems = vm.gridData.length;
                     filterGridData();
                 }, function(){
                     // push errors
                 });
             });
        }

		function translateGroupEvent(group) {
			if(vm.granPermsAccess) {
				if (group.lastEvent === 'CREATED') {
					group.lastevent = vm.eventCreated;
				} else if (group.lastEvent === 'MODIFIED') {
					group.lastevent = vm.eventModified;
				} else if (group.lastEvent === 'DELETED') {
					group.lastevent = vm.eventDeleted;
				} else if (group.lastEvent === 'NOT_AVAILABLE') {
					group.lastevent = vm.eventNotAvailable;
				}
				if(group.eventDate !== null) {
					group.lasteventdate = $window.moment.utc(group.eventDate).format('L LT');
				}
				group.eventby = group.eventBy;
			}
		}

        function isSystemGroup(permissionGroupType) {
           return groupsService.isSystemGroup(permissionGroupType);
        }

        function getHistory(group) {
            $uibModal.open({
                templateUrl: 'components/permission-groups-list/export/history-modal.html',
                controllerAs: 'ctrl',
                size: 'lg',
                controller: 'bmPermGroupHistoryModalCtrl',
                resolve: {
                    group: function() {
                        return group;
                    }
                }
            });
        }
        function containsString(target, value) {
            return target.toLowerCase().indexOf(value.toLowerCase()) >= 0;
        }

        function filterGridData() {
            var value = vm.filterOptions.filterText;
            vm.filteredGridData = $filter('filter')(vm.gridData, function(item) {
                if(vm.granPermsAuditAccess && !vm.showDeletedGroups && item.deleted){
                    return false;
                }
                return containsString(item.name, value) || containsString(item.description, value);
            });
        }

        vm.deleteToggleChange = function() {
            vm.showDeletedGroups = !vm.showDeletedGroups;
            filterGridData();

        };

        vm.columnDefs = [
            { field: 'name', width: '*', },
            { field: 'description', width: '**' },
            { field: 'lastevent', width: '*' },
            { field: 'eventby', width: '*' },
            { field: 'lasteventdate', width: '**' },
        ];

        var getTranslations = function() {
            $q.all([
                $translate('Bluemoon.Core.Setup.Groups.NameLabel'),
                $translate('Bluemoon.Core.Setup.Groups.DescLabel'),
                $translate('Bluemoon.Core.Setup.Groups.LastEventLabel'),
                $translate('Bluemoon.Core.Setup.Groups.EventByLabel'),
                $translate('Bluemoon.Core.Setup.Groups.LastEventDateLabel'),
                $translate('Bluemoon.Core.Setup.Groups.Add'),
                $translate('Bluemoon.Core.Setup.Groups.Edit'),
                $translate('Bluemoon.Core.Setup.Groups.Delete'),
                $translate('Bluemoon.Setup.Groups.Actions'),
                $translate('Bluemoon.Core.Setup.Groups.LastEvent.Created'),
                $translate('Bluemoon.Core.Setup.Groups.LastEvent.Modified'),
                $translate('Bluemoon.Core.Setup.Groups.LastEvent.Deleted'),
                $translate('Bluemoon.Core.Setup.Groups.LastEvent.NotAvailable'),
                $translate('Bluemoon.Core.Setup.Groups.MoreInfo')
            ]).then(function(translations){
                vm.columnDefs[0].displayName = translations[0];
                vm.columnDefs[1].displayName = translations[1];
                vm.columnDefs[2].displayName = translations[2];
                vm.columnDefs[3].displayName = translations[3];
                vm.columnDefs[4].displayName = translations[4];
                vm.toolbarButtons[0].label = translations[5];
                vm.toolbarButtons[1].label = translations[6];
                vm.toolbarButtons[2].label = translations[7];
                vm.actionsHeader = translations[8];
                vm.eventCreated = translations[9];
                vm.eventModified = translations[10];
                vm.eventDeleted = translations[11];
                vm.eventNotAvailable = translations[12];
                vm.infoAriaLabel = translations[13];
                if (vm.gridData) {
                    vm.gridData.forEach(function(group) {
						translateGroupEvent(group);
                    });
                }
            });
        };

        vm.toolbarButtons = [{
                id: 'bm-perm-grps-list-grid-toolbar-add',
                icon  : 'bento-icon-add',
                action: function() {
                    $state.go('setup-permission-groups-new');
                }
            },
            {
                id: 'bm-perm-grps-list-grid-toolbar-edit',
                icon    : 'bento-icon-edit',
                action  : function() {
                    if (vm.selectedGroups.length === 1) {
                        $state.go('setup-permission-groups-edit', { groupId: vm.selectedGroups[0].subjectGroupId });
                    }
                }
            },
            {
                id: 'bm-perm-grps-list-grid-toolbar-remove',
                icon    : 'bento-icon-remove',
                action  : function() {
                    if (vm.selectedGroups.length > 0) {
                        var deleteConfModalInstance = $uibModal.open({
                            templateUrl: 'permGroupDeleteConfirmation.html',
                            size: 'sm',
                            controllerAs: 'conf',
                            controller: function() {
                                this.confirmDelete = function() {
                                    groupsService.deleteGroups(vm.selectedGroups).then(function() {
                                        $timeout(function() {
                                            deleteConfModalInstance.close();
                                            vm.selectedGroups = [];
                                            init();
                                        });
                                    });
                                };
                                this.cancelDelete = function() {
                                    deleteConfModalInstance.dismiss();
                                };
                            }
                        });
                    }
                }
            }
        ];

        // translate promise doesn't resolve on browser refresh unless delayed till next cycle
        $timeout(getTranslations);
        // handle lang change
        $rootScope.$on('bmLanguageChangeSuccess', getTranslations);

        function onHeaderCheckboxChange() {
            vm.selectedGroups = [];
            vm.allSelected = !vm.allSelected;
                for (var i = 0, ttl = vm.flexGrid.rows.length; i < ttl; i++) {
                    // skip system group
                    if(!isSystemGroup(vm.flexGrid.rows[i].dataItem.permissionGroupType)) {
                        vm.flexGrid.rows[i].dataItem.selected = vm.allSelected;
                        var item = vm.flexGrid.rows[i].dataItem;
                        if(vm.allSelected) {
                            vm.selectedGroups = vm.selectedGroups.concat(item);
                        }
                    }
                }
        }
        function onCheckboxChange(item) {
            if(item.selected) {
                vm.selectedGroups = vm.selectedGroups.concat(item);
            } else {
                vm.selectedGroups = vm.selectedGroups.filter(function(subjectGroup){
                    return subjectGroup.subjectGroupId !== item.subjectGroupId;
                });
            }
            updateHeaderCheckbox();
        }
        function updateHeaderCheckbox() {
            vm.allSelected = false;
            var count = 0;
            for (var i = 0, ttl = vm.flexGrid.rows.length; i < ttl; i++) {
                if (vm.flexGrid.rows[i].dataItem.selected === true) {
                    count++;
                }
            }
            if (count === vm.flexGrid.rows.length) {
                vm.allSelected = true;
            }
        }
        function toggleEquationVisibility() {
            $scope.$broadcast('bm-equation-visibility-toggle');
        }
    }
})(window.angular);

/*
 * Permission Groups History Modal
*/
(function(angular){
	'use strict';
	angular.module('bmPermissionGroupsList').controller('bmPermGroupHistoryModalCtrl', PermGroupsHistoryModal);

	PermGroupsHistoryModal.$inject = ['$scope', '$translate', '$uibModalInstance', '$q', 'bm.permissiongroups.PermissionGroupsService', 'group'];
	function PermGroupsHistoryModal($scope, $translate, $uibModalInstance, $q, groupsService, group) {
		var ctrl = this;
        ctrl.close = close;
        ctrl.$onInit = function() {
            translateJsStrings().then(function(){
                ctrl.staffGridColumns = [
                    { header : ctrl.dateHeader, binding : 'eventTimestamp', width : 100},
                    { header : ctrl.changeHeader, binding : 'metadata.change', width : '*'},
                    { header : ctrl.permGroupHeader, binding : 'metadata.permissionGroup', width : '*'},
                    { header : ctrl.changedByHeader, binding : 'metadata.changedBy', width : '*'},
                    { header : ctrl.ipAddressHeader, binding : 'clientIp', width : 114}
                ];
            });
            ctrl.isLoading = true;
            groupsService.getGroupHistory(group.subjectGroupId).then(function(events){
                ctrl.isLoading = false;
                ctrl.itemsLoaded = events.data.items.length;
                var cv = new wijmo.collections.CollectionView( // jshint ignore:line
                    events.data.items.map(function(event){
                        event.metadata = JSON.parse(event.metadata);
                        event.metadata.change = ctrl.changeValues.get(event.metadata.change);
                        event.eventTimestamp = moment(event.eventTimestamp).format('YYYY-MM-DD'); // jshint ignore:line
                        return event;
                    })
                );
                cv.sortDescriptions.push(new wijmo.collections.SortDescription('eventTimestamp', false)); // jshint ignore:line
                ctrl.flex.itemsSource = cv;
            }, function(){
                ctrl.isLoading = false;
            });
        };

        function close() {
            $uibModalInstance.dismiss('cancel');
        }
		function translateJsStrings() {
            return $q.all([
                $translate('Reports.OnvioUsage.ColumnHeader.PermGroupChange'),
                $translate('Reports.OnvioUsage.ColumnHeader.PermGroup'),
                $translate('Reports.OnvioUsage.ColumnHeader.ChangedByHeader'),
                $translate('Reports.OnvioUsage.ColumnHeader.Date'),
                $translate('Reports.OnvioUsage.ColumnHeader.IpAddress'),
                $translate('Created permission group'),
                $translate('Deleted permission group'),
                $translate('Modified permission group')
            ]).then(function(translations) {
                ctrl.changeHeader = translations[0];
                ctrl.permGroupHeader = translations[1];
                ctrl.changedByHeader = translations[2];
                ctrl.dateHeader = translations[3];
                ctrl.ipAddressHeader = translations[4];
                ctrl.changeValues = new Map();
                ctrl.changeValues.set('Created permission group', translations[5]);
                ctrl.changeValues.set('Deleted permission group', translations[6]);
                ctrl.changeValues.set('Modified permission group', translations[7]);
            });
        }
	}
})(window.angular);

/*
 * Permission Groups Data Component
*/
(function(angular){
	'use strict';

	angular.module('bmPermissionGroupsData', [ 'bm-permission-groups.component.templates'] )
		.component('bmPermissionGroupsData', {
			templateUrl: 'components/permission-groups-data/export/permission-groups-data.html',
			controller: PermissionGroupsDataCtrl,
			controllerAs: 'vm',
			bindings: {
				groupData: '<',
                readOnly: '<',
                onFiltersChange: '&'
			}
		});
	PermissionGroupsDataCtrl.$inject = [
        'bm.permissiongroups.PermissionGroupsService',
        'AuthenticatedSessionData',
        '$translate',
        '$scope',
        'bmAccess',
        '$q'
	];

	function PermissionGroupsDataCtrl (
		groupsService,
		session,
        $translate,
        $scope,
        bmAccess,
        $q
	) {
        /*jshint validthis:true */
        var vm = this;
        vm.selectedContactsChanged = selectedContactsChanged;
        vm.selectedContactsToggleChange = selectedContactsToggleChange;

        vm.allConfSelectionChanged = allConfSelectionChanged;
        vm.selectedStaffToggleChange = selectedStaffToggleChange;
        vm.updateConfContactFilter = updateConfContactFilter;
        vm.selectedTemplatesToggleChange = selectedTemplatesToggleChange;
        vm.allTemplatesSelectionChanged = allTemplatesSelectionChanged;
        vm.selectedTemplatesChanged = selectedTemplatesChanged;
        vm.updateNonConfContactFilter = updateNonConfContactFilter;

        $scope.$on('nextClick', function() {
            // TODO: set a default value if step is skipped
            if(vm.groupData) {
                validateFilters(vm.groupFilters);
                vm.onFiltersChange({
                    $event: {
                        filters: vm.groupFilters
                    }
                });
            }
        });
        $scope.$on('groupDataStep', function() {
            // Get perms on arrival
            vm.templateFolderPermission = false;
            vm.perms = groupsService.groupPerms;
            checkTemplateFolderPermission();
        });
        vm.$onInit = function() {
            vm.perms = [];
            vm.templateFolderPermission = false;
            if(vm.groupData) {
                checkTemplateFolderPermission();
                vm.groupFilters = vm.groupData.data.filters || [];
            }
            initializeInterface();
            getClients(vm.itemsPerPage, vm.clientStartIndex);

            if(!vm.readOnly) {
                getFolderTemplates();
            }
            getDynamicTranslations();
        };
        vm.$onChanges = function(changes) {
            vm.groupFilters = [];
            if(changes.groupData && changes.groupData.currentValue) {
                vm.groupFilters = changes.groupData.currentValue.data.filters;
            }
            initializeInterface();
            getClients(vm.itemsPerPage, vm.clientStartIndex);
        };
        function initializeInterface() {
            // initialize Non-confidential contact checkbox
            vm.nonConfContactsSelected = vm.groupFilters.filter(function(filter) {
                return filter.type === 'nonconfidential_contact';
            }).length > 0;

            // initialize confidential contact checkbox
            var confContactsFilter = vm.groupFilters.filter(function(filter) {
                return filter.type === 'confidential_contact';
            })[0] || null;
            vm.confContactsSelected = confContactsFilter ? true : false;

            vm.noContact = vm.groupFilters.filter(function(filter) {
                return filter.type === 'no_contact';
            }).length > 0;
            // initialize selected contacts toggle
            vm.selectedContacts = !vm.noContact && vm.nonConfContactsSelected || vm.confContactsSelected;

            // initialize map used in determining selected vs not-selected confidential contacts
            vm.confContactFilterValues = [];
            // initalize value of 'all confidential' and 'selected confidential' radio button group
            vm.selectedConfContacts = '';

            // initialize map used in determining selected vs not-selected template folders
            vm.selectedTemplatesListIdMap = {};
            vm.selectedTemplatesFilter = vm.groupFilters.filter(function(filter){
                return filter.type === 'template_folder';
            })[0] || null;

            vm.selectedTemplates = vm.selectedTemplatesFilter ? true : false;
            vm.allTemplates = '';
            if(vm.selectedTemplates) {
                vm.allTemplates = vm.selectedTemplatesFilter.filterValues.filter(function(filterValue) {
                    return filterValue.referenceId === '$all';
                }).length > 0;
                if(!vm.allTemplates) {
                    vm.selectedTemplatesFilter.filterValues.forEach(function(filterValue) {
                        vm.selectedTemplatesListIdMap[filterValue.referenceId] = true;
                    });
                }
            }

            if(confContactsFilter) {
                vm.confContactFilterValues = confContactsFilter.filterValues;
                vm.selectedConfContacts = confContactsFilter.filterValues.filter(function(filterValue){
                    return filterValue.referenceId !== '$all';
                }).length > 0;
            }
            vm.hideContactFilters = true;
            bmAccess.has('Platform_DisableAccessibleContacts').then(function (disableAccessibleContacts){
                vm.hideContactFilters = disableAccessibleContacts;
            }).catch(function(){
                vm.hideContactFilters = false;
            });
        }
        function getDynamicTranslations() {
            var promises = [
                $translate('Bluemoon.Core.Setup.Groups.SelectedText'),
                $translate('bm.permissiongroups.relative.office'),
                $translate('bm.permissiongroups.relative.name'),
                $translate('bm.permissiongroups.relative.supervisor'),
                $translate('Bluemoon.Core.Setup.Groups.ClientData.ClientOfficeMatches')
            ];
            $q.all(promises).then(function(resps) {
                vm.selectedText = resps[0];
                vm.relativeOffice = resps[1];
                vm.relativeName = resps[2];
                vm.relativeSupervisor = resps[3];
                vm.clientOfficeDropdownLabel = resps[4];
            });
        }
        function updateConfContactFilter() {
            vm.groupFilters = vm.groupFilters.filter(function(groupFilter) {return groupFilter.type !== 'confidential_contact';});
            if(vm.confContactsSelected) {
                if (vm.clientList.length === 0) {
                    vm.selectedConfContacts = false;
                    allConfSelectionChanged();
                    return;
                } else {
                    vm.selectedConfContacts = '';
                }
            } else {
                vm.selectedConfContacts = '';
            }

            vm.onFiltersChange({
                $event: {
                    filters: vm.groupFilters,
                    disableNext: isNextDisabled()
                }
            });
        }
        function selectedContactsChanged() {
            vm.groupFilters = vm.groupFilters.filter(function(groupFilter) {return groupFilter.type !== 'confidential_contact';});
            // unselect "Selected Confidential Clients" if none selected
            if( !angular.isArray(vm.selectedContactsList) || vm.selectedContactsList.length === 0 ) {
                vm.selectedConfContacts = '';
                vm.confContactsSelected = false;
                allConfSelectionChanged();
                return;
            }
            var filterValues = vm.selectedContactsList.map(function(selectedContact) {
                return {displayName: selectedContact.name, referenceId: selectedContact.referenceId, selected: true };
            });
            vm.groupFilters = vm.groupFilters.concat([{
                type: 'confidential_contact',
                filterValues: filterValues
            }]);
            vm.onFiltersChange({
                $event: {
                    filters: vm.groupFilters
                }
            });
        }
        function selectedContactsToggleChange() {
            vm.groupFilters = vm.groupFilters.filter(function(groupFilter) { return groupFilter.type !== 'no_contact' && groupFilter.type !== 'confidential_contact' && groupFilter.type !== 'nonconfidential_contact' ;});
            // reset groupData if "No Contacts" is selected
            if(!vm.selectedContacts) {
                vm.groupFilters = vm.groupFilters.concat([{
                    type: 'no_contact',
                    filterValues: []
                }]);
                vm.selectedContactsList = [];
                vm.selectedContacts = false;
                vm.selectedConfContacts = '';
                vm.confContactsSelected = false;
                vm.nonConfContactsSelected = false;
                vm.onFiltersChange({
                    $event: {
                        filters: vm.groupFilters
                    }
                });
            }
            // set defaults if "Contacts" is selected
            if(vm.selectedContacts) {
                vm.selectedContactsList = [];
                vm.selectedContacts = true;
                vm.selectedConfContacts = '';
                vm.confContactsSelected = false;
                vm.nonConfContactsSelected = true;
                updateNonConfContactFilter();
            }
        }
        function selectedStaffToggleChange() {
        }
        function allConfSelectionChanged() {
            // remove old confidential_contact filter
            vm.groupFilters = vm.groupFilters.filter(function(groupFilter) {return groupFilter.type !== 'confidential_contact';});
            vm.selectedContactsList = [];
            if(vm.selectedConfContacts) {
                vm.groupFilters = vm.groupFilters.concat([{
                    type: 'confidential_contact',
                    filterValues: []
                }]);
            } else if(vm.selectedConfContacts === false){
                vm.groupFilters = vm.groupFilters.concat([{
                    type: 'confidential_contact',
                    filterValues: [{
                        referenceId: '$all',
                        displayName: 'All Confidential',
                        selected: true
                    }]
                }]);
            }

            vm.onFiltersChange({
                $event: {
                    filters: vm.groupFilters,
                    disableNext: isNextDisabled()
                }
            });
        }
        function getClients(){
            session.getBindings().then(function(data){
                vm.loadingClients = true;
                groupsService.loadConfidentialContacts(data.ApplicationConfiguration.CompanyId).then(function(data) {
                    vm.loadingClients = false;
                    vm.clientList = data.map(function(contact) { return { name: contact.name, referenceId: contact.id, displayName: contact.name };});
                    vm.confContactFilterValues = vm.confContactFilterValues.filter(function(filterValue){
                        var contactIsConfidential = false;
                        vm.clientList.forEach(function(confidentialContact){
                            if (filterValue.referenceId === confidentialContact.referenceId) {
                                contactIsConfidential = true;
                            }
                        });
                        return contactIsConfidential;
                    });
                    vm.selectedContactsList = vm.clientList.filter(function(item){
                        var isSelected = false;
                        vm.confContactFilterValues.forEach(function(filterValue){
                            if(item.referenceId === filterValue.referenceId) {
                                isSelected = true;
                            }
                        });
                        return isSelected;
                    });
                    if(vm.selectedConfContacts && vm.selectedContactsList.length === 0) {
                        vm.groupFilters = vm.groupFilters.filter(function(filter) {
                            return filter.type !== 'confidential_contact';
                        });
                    }
                    initializeInterface();
                });
            });
        }
        function getFolderTemplates(){
            groupsService.loadFolderTemplates().then(function(resp){
                vm.folderTemplatesList = resp.data.data.map(function(templateFolder) {
                    return {displayName: templateFolder.name, name: templateFolder.name, referenceId: templateFolder.id, selected: false };
                });
                vm.selectedTemplatesList = vm.folderTemplatesList.filter(function(item){
                    return vm.selectedTemplatesListIdMap[item.referenceId] !== undefined;
                });
            });
        }

        function checkTemplateFolderPermission() {
            var docPermission =  vm.perms.filter(function(perm){
                return perm.displayName === 'Documents' && perm.value;
            })[0] || null;
            if(docPermission) {
                checkDocumentPermission(docPermission);
            } else {
                if(vm.groupData.data.id) {
                    groupsService.getGroupPermissions(vm.groupData.data.id.replace(/-/g, '').toUpperCase()).then(function(resp){
                        docPermission = resp.data.filter(function(perm){ return perm.displayName === 'Documents'; })[0] || null;
                        if(docPermission) {
                            groupsService.loadGroupPermDetails(docPermission).then(function(){
                                checkDocumentPermission(docPermission);
                            });
                        }
                    });
                }
            }
        }
        function checkDocumentPermission(documentPermission) {
            if(!documentPermission) {return;}
            if( documentPermission.value === 'ALL') {
                vm.templateFolderPermission = true;
                return;
            } else if (documentPermission.value === 'SOME') {
                var clientDocumentsPermission = documentPermission.children.filter(function(child){
                    return child.key === 'OnvioDrive.ClientDocuments';
                })[0] || null;
                vm.templateFolderPermission = clientDocumentsPermission ? clientDocumentsPermission.value === 'ALL' : false;
            }
        }
        function updateNonConfContactFilter() {
            // remove old filter
            vm.groupFilters = vm.groupFilters.filter(function(filter) {return filter.type !== 'nonconfidential_contact';});
            // add new filter if toggled on
            if(vm.nonConfContactsSelected) {
                vm.groupFilters = vm.groupFilters.concat([{
                    type: 'nonconfidential_contact',
                    filterValues: [{
                        referenceId: '$all',
                        displayName: 'all nonConfidential',
                        selected: true
                    }]
                }]);
            }

            vm.onFiltersChange({
                $event: {
                    filters: vm.groupFilters,
                    disableNext: isNextDisabled()
                }
            });
        }
        function isNextDisabled() {
            var disableNextButton = null;
            // neither confidential nor non-confidential contacts selected
            if(!vm.confContactsSelected && !vm.nonConfContactsSelected) {
                disableNextButton = true;
            }
            // confidential is selected, but user hasn't selected some or all confidential contacts
            if(vm.confContactsSelected && vm.selectedConfContacts === '') {
                disableNextButton = true;
            }
            // user selects confidential contacts -> selected confidential has does not made a selection
            if(vm.selectedConfContacts && vm.selectedContactsList.length === 0 ) {
                disableNextButton = true;
            }
            return disableNextButton;
        }
        function validateFilters(groupFilters) {
            var confContactsFilter = groupFilters.filter(function(filter) {
                return filter.type === 'confidential_contact';
            })[0] || null;
            // filter of type condfidential_contact with no filterValues is invalid, remove from vm.groupFilters
            if(confContactsFilter && confContactsFilter.filterValues.length === 0){
                vm.groupFilters = vm.groupFilters.filter(function (filter){
                    return filter.type !== 'confidential_contact';
                });
            }
            initializeInterface();
        }
        function allTemplatesSelectionChanged() {
        // remove old confidential_contact filter
            vm.groupFilters = vm.groupFilters.filter(function(groupFilter) {return groupFilter.type !== 'template_folder';});
            vm.selectedTemplatesList = [];
            if(vm.allTemplates) {
                vm.groupFilters = vm.groupFilters.concat([{
                    type: 'template_folder',
                    filterValues: [{
                        referenceId: '$all',
                        displayName: 'All templates',
                        selected: true
                    }]
                }]);
            } else {
                vm.groupFilters = vm.groupFilters.concat([{
                    type: 'template_folder',
                    filterValues: []
                }]);
            }
            vm.onFiltersChange({
                $event: {
                    filters: vm.groupFilters
                }
            });
        }
        function selectedTemplatesChanged() {
            vm.groupFilters = vm.groupFilters.filter(function(groupFilter) {return groupFilter.type !== 'template_folder';});
            // unselect "Selected Shared Templates" if none selected
            if( !angular.isArray(vm.selectedTemplatesList) || vm.selectedTemplatesList.length === 0 ) {
                vm.allTemplates = true;
                allTemplatesSelectionChanged();
                return;
            }
            var filterValues = vm.selectedTemplatesList.map(function(selectedTemplate) {
                return {displayName: selectedTemplate.name, referenceId: selectedTemplate.referenceId, selected: true };
            });
            vm.groupFilters = vm.groupFilters.concat([{
                type: 'template_folder',
                filterValues: filterValues
            }]);
            vm.onFiltersChange({
                $event: {
                    filters: vm.groupFilters
                }
            });
        }
        function selectedTemplatesToggleChange() {
            vm.groupFilters = vm.groupFilters.filter(function(groupFilter) {return groupFilter.type !== 'template_folder';});
            vm.selectedTemplatesList = [];
            vm.allTemplates = '';
            vm.onFiltersChange({
                $event: {
                    filters: vm.groupFilters
                }
            });
        }
    }
})(window.angular);

(function(angular) {
    'use strict';

    /* EXPORT */
    angular.module('bm.permissiongroups.PermissionGroupsService', ['bmUser'])
        .service('bm.permissiongroups.PermissionGroupsService', PermissionGroups)
        .value('bm.permissiongroups.GroupsUrl', '/api/profiles/v1/permissions/subject-groups')
        .value('bm.permissiongroups.GroupListUrl', '/api/permissions/v2/groups/')
        .value('bm.permissiongroups.GroupDetailUrl', '/api/profiles/v1/permissions/subject-groups/{groupId}')
        .value('bm.permissiongroups.GroupPermsUrl', '/api/permissions/v1/groups/{groupId}/features')
        .value('bm.permissiongroups.GroupPermDetailPostUrl', '/api/profiles/v1/permissions/all/{groupId}')
        .value('bm.permissiongroups.StaffUrl', '/api/core/v2/companies/{companyId}/employee-views/search')
        .value('bm.permissiongroups.EmployeeUrl', '/api/core/v2/companies/{companyId}/employee-views/search')
        .value('bm.permissiongroups.ConfidentialContactUrl', '/api/core/v1/companies/{companyId}/confidential-contacts?itemsPerPage=1000&orderBy=code+asc&search=&searchBy=code,name&startIndex={startIndex}&expand=code,name,contactView.id')
        .value('bm.permissiongroups.ClientUrl', '/api/core/v1/companies/{companyId}/contact-views/search')
        .value('bm.permissiongroups.GroupMembersUrl', '/api/permissions/v1/groups/{groupId}/members')
        .value('bm.permissiongroups.GroupPermMemAllInOnePostPutUrl', '/api/permissions/v2/groups/{groupId}')
        .value('bm.permissiongroups.GroupDataUrl', '/api/permissions/v1/groups/')
        .value('bm.permissiongroups.PreferenceUrl', '/api/profiles/v2/preferences/applications/{application}/categories/{category}/contacts/{contactId}')
        .value('bm.permissiongroups.officeUrl', '/api/core/v1/companies/{companyId}/office-views/search')
        .value('bm.permissiongroups.auditEventsUrl', '/api/audit-events/v1/events/objects/{groupId}?itemsPerPage=1000')
        .value('bm.permissiongroups.companyMainUrl', '/api/core/v1/companies/{companyId}/main')
        .value('bm.permissiongroups.folderTemplatesUrl', '/api/storage/v1/projects?primaryAssociationId=Templates&primaryAssociationType=Firm&productType=DMSClientFolder&customFields=[{"Name":"allClients","Value":"true"}]');

    PermissionGroups.$inject = [
        '$http',
        '$q',
        'bmUser',
        'bm.permissiongroups.GroupsUrl',
        'bm.permissiongroups.GroupListUrl',
        'bm.permissiongroups.GroupDetailUrl',
        'bm.permissiongroups.GroupPermsUrl',
        'bm.permissiongroups.GroupPermDetailPostUrl',
        'bm.permissiongroups.StaffUrl',
        'bm.permissiongroups.EmployeeUrl',
        'bm.permissiongroups.ConfidentialContactUrl',
        'bm.permissiongroups.ClientUrl',
        'bm.permissiongroups.GroupMembersUrl',
        'bm.permissiongroups.GroupPermMemAllInOnePostPutUrl',
        'bm.permissiongroups.GroupDataUrl',
        'bm.permissiongroups.PreferenceUrl',
        'bm.permissiongroups.officeUrl',
        'bm.permissiongroups.auditEventsUrl',
        'bm.permissiongroups.companyMainUrl',
        'bm.permissiongroups.folderTemplatesUrl',
        'bmAccess'
    ];

    /*
     * PermissionGroups Constructor
     */
    function PermissionGroups(
            $http,
            $q,
            bmUser,
            groupsUrl,
            groupListUrl,
            groupDetailUrl,
            permsUrl,
            permDetailPostUrl,
            staffUrl,
            employeeUrl,
            confidentialContactUrl,
            clientUrl,
            membersUrl,
            grpPermMemPostPutUrl,
            grpPermDataUrl,
            preferenceUrl,
            officeUrl,
            grpPermAuditEventsUrl,
            companyMainUrl,
            folderTemplatesUrl,
            bmAccess) {

        var self = this,
            SUBJECT_GROUP_TYPE_ID = 'contacts';

        var systemTypes = [
            'system',
            'system.allFunctionality',
            'system.administrators'
        ];

        /* PROPS */
        function init() {
            self.list = [];
            self.groupPerms = [];
            self.staff = [];
        }

        /* METHODS */
        self.init = init;

        function reset() {
            // arr.length = 0 is a technique to clear Array items w/o reseting the reference
            self.list.length = 0;
            self.groupPerms.length = 0;
            self.staff.length = 0;
        }

        self.clearList = function() {
            self.list.length = 0;
        };

        self.clearSelectedPerms = function() {
            self.groupPerms.length = 0;
        };

        self.clearStaff = function() {
            self.staff.length = 0;
        };

        self.isSystemGroup = function(permissionGroupType) {
            return systemTypes.indexOf(permissionGroupType) !== -1;
        };

        self.loadGroupList = function(showDeleted) {
            reset();
            var url = groupListUrl;
            if(showDeleted){
                url += '?showDeleted=true';
            }
            return $http({
                url: url
            }).then(function(resp) {
                // clear arrays
                reset();
                // fill array
                resp.data.forEach(function(group) {
                    // need both guid formats for now
                    group.permissionGroupId = group.id;

                    self.list.push(group);
                });
            });
        };

        self.loadSubjectGroups = function() {
            return $http.get(groupsUrl);
        };

        self.getContactsGroupList = function(_contactIds) {
            var req = $http.get(groupsUrl, {
                params: { contactIds: _contactIds.join() }
            }).then(function(resp) {
                return resp.data.dtos;
            });

            return req;
        };
        self.getContactsGroups = function(_contactIds) {
            return $http.get(groupsUrl, { params: { contactIds: _contactIds.join() } });
        };

        self.loadGroupDetail = function(groupId) {
            var req = $http.get(groupDetailUrl.replace('{groupId}', groupId));
            return req;
        };

        self.isGroupNameUnique = function(name) {
            var req = $http({
                    url: groupsUrl,
                    params: { name: name, type: SUBJECT_GROUP_TYPE_ID }
                }).then(function(resp) {
                    return resp.data.dtos.length === 0;
                });

            return req;
        };

        self.loadGroupPerms = function(groupId) {
            var req = $http({
                url: permsUrl.replace('{groupId}', groupId || 'new')
            }).then(function(resp) {
                // make sure we have user's language before sorting perm tabs
                bmUser.load().then(function() {
                    self.clearSelectedPerms();
                    resp.data.forEach(function(permset) {
                        self.groupPerms.push(permset);
                    });
                    self.groupPerms.sort(getGroupPermsCompareFn(bmUser.language));
                });
            });

            return req;
        };
        self.getGroupPermissions = function(groupId) {
            var req = $http({
                url: permsUrl.replace('{groupId}', groupId || 'new')
            });

            return req;
        };
        self.loadGroupPermsTabs = function(groupId) {
            var req = $http({
                url: permsUrl.replace('{groupId}', groupId || 'new')
            }).then(function(resp) {
                // make sure we have user's language before sorting perm tabs
                bmUser.load().then(function() {
                    self.clearSelectedPerms();
                    resp.data.forEach(function(permset) {
                        self.groupPerms.push(permset);
                    });
                    self.groupPerms.sort(getGroupPermsCompareFn(bmUser.language));
                });
            });

            return req;
        };

        self.loadGroupPermDetails = function(permNode) {
            var _url = permNode.url.replace(/.*?(\/api\/.*)/, '$1');

            var config = {
                url: _url
            };

            return loadPermDetails(permNode, config);
        };

        self.loadContactsPermDetails = function(permNode, _contactIds) {
            var _url = permNode.url.replace(new RegExp('.*(/api/.*/permissions/).*/tabs/(.*)'), '$1$2');
            _contactIds = _contactIds.join();

            var config = {
                url: _url,
                params: {contactIds: _contactIds}
            };

            return loadPermDetails(permNode, config, true);
        };

        function loadPermDetails(permNode, httpReqConfig, forceFlag) {
            // if permNode details are already loaded, do nothing
            if (permNode.type && !forceFlag) { return; }

            var req = $http(httpReqConfig).then(function(resp) {

                if (resp.data.key === 'OnvioSetup.AllPermissions') {
                    bmAccess.has('HideConfidentialContactsFromSetup').then(function() {
                        var index = resp.data.children.findIndex(function(element) {
                            return element.key === 'Platform.ConfidentialClients';
                        });
                        resp.data.children.splice(index,1);
                    });
                }
                // merge details into permNode
                angular.extend(permNode, resp.data);
                visit(permNode, addParentPointers);
            });

            return req;
        }
        self.loadGroupFilters = function(permGrpId) {
            var groupUrl = grpPermDataUrl + permGrpId;

            return $http({
                url: groupUrl,
                method: 'GET'
            }).then(function(resp) {
                /* Set system property */
                resp.data.system = self.isSystemGroup(resp.data.permissionGroupType);
                return resp;
            }).catch(function(resp){
                /* Suppress error on valid 404 (not every subjectGroup will have a 'Data' component), default to all non-confidential */
                if(resp.status === 404){
                    resp.config.global = false;
                    return {
                        data: {
                            company: '',
                            description: '',
                            name: '',
                            id: '',
                            filters: [{
                                filterValues: [{
                                    displayName: 'all nonConfidential',
                                    referenceId: '$all',
                                    selected: true
                                }],
                                type: 'nonconfidential_contact'
                            }],
                            system: false
                        }
                    };
                }
            });
        };
        self.loadPermGrps = function() {
            return $http.get(grpPermDataUrl);
        };
        self.loadPermGrp = function(permGrpId) {
            var groupUrl = grpPermDataUrl + permGrpId;

            return $http({
                url: groupUrl,
                method: 'GET'
            }).then(function(resp) {
                var permissionGroup = {
                    selectedContactsList: [],
                    selectedContacts: false,
                    selectedConfContacts: '',
                    contactsSelected: {
                        nonConf : false,
                        conf : false
                    }
                };
                resp.data.filters.forEach(function(filter) {
                    if(filter.type === 'confidential_contact' || filter.type === 'nonconfidential_contact') {
                        permissionGroup.selectedContacts = true;
                    }
                    if (filter.type === 'nonconfidential_contact') {
                        permissionGroup.contactsSelected.nonConf = true;
                    }
                    if (filter.type === 'confidential_contact') {
                        permissionGroup.contactsSelected.conf = true;
                        permissionGroup.selectedConfContacts = false;
                        if(filter.filterValues.length > 0 && filter.filterValues[0].referenceId !== '$all') {
                            permissionGroup.selectedConfContacts = true;
                            permissionGroup.selectedContactsList = filter.filterValues.filter(function(ref){ return ref.selected;});
                        }
                    }
                });
                return permissionGroup;
            }).catch(function(resp){
                /* Suppress error on valid 404 (not every subjectGroup will have a 'Data' component) */
                if(resp.status === 404){
                    resp.config.global = false;
                    return {
                        selectedContactsList: [],
                        selectedContacts: false,
                        selectedConfContacts: '',
                        contactsSelected: {
                            nonConf : true,
                            conf : false
                        }
                    };
                }
            });
        };
        self.loadStaffAndMembers = function(companyId, groupId, callback1, callback2, callback3) {
            var staffReq = $http({
                    method: 'POST',
                    url: staffUrl.replace('{companyId}', companyId),
                    data: {
                        'expand': 'code,name,contactView.isStaffCenterEnabled,contactView.id',
                        'excludeCount': true,
                        'filterSearchSort': {
                          'orderBy': 'code asc',
                          'search': '',
                          'searchBy': 'code,name',
                          'filter': ''
                        },
                        'pagingDataRequest': {
                          'startIndex': 1,
                          'pageIndex': 0,
                          'itemsPerPage': 1000
                        }
                      }
                }),
                membersReq = $http({
                    url: membersUrl.replace('{groupId}', groupId)
                }),
                reqs = $q.all([staffReq, membersReq]),
                memberIdMap = {};

            // build map for fast lookups
            membersReq.then(function(resp) {
                resp.data.members.forEach(function(item) {
                    memberIdMap[item.subjectId] = true;
                });
            });

            reqs.then(function(resps) {
                var totalPages = resps[0].data.totalPages;
                var staff = resps[0].data.items;
                if (totalPages === 1) {
                    self.clearStaff();
                    staff.forEach(function(item) {
                        // onvio center enabled staff only!
                        if (item.contactView.isStaffCenterEnabled) {
                            // is a member?
                            item.__isMember = memberIdMap[item.contactView.id] !== undefined;
                            self.staff.push(item);
                        }
                    });
                    callback1();
                    callback2();
                    callback3();
                } else {
                    for (var i = 1; i < totalPages; i++) {
                        var staffreq2 = $http({
                            method: 'POST',
                            url: staffUrl.replace('{companyId}', companyId),
                            data: {
                                'expand': 'code,name,contactView.isStaffCenterEnabled,contactView.id',
                                'excludeCount': true,
                                'filterSearchSort': {
                                  'orderBy': 'code asc',
                                  'search': '',
                                  'searchBy': 'code,name',
                                  'filter': ''
                                },
                                'pagingDataRequest': {
                                  'startIndex': (i * 1000) + 1,
                                  'pageIndex': 0,
                                  'itemsPerPage': 1000
                                }
                              }
                        });
                        staffreq2.then(function(response) { // jshint ignore:line
                            staff = staff.concat(response.data.items);
                            self.clearStaff();
                            staff.forEach(function(item) {
                                // onvio center enabled staff only!
                                if (item.contactView.isStaffCenterEnabled) {
                                    // is a member?
                                    item.__isMember = memberIdMap[item.contactView.id] !== undefined;
                                    self.staff.push(item);
                                }
                            });
                            callback1();
                            callback2();
                            callback3();
                        });
                    }
                }
            });
            return reqs;
        };
        /* Allows you to load staff and members without providing 3 callback functions */
        self.loadStaffAndMembersNoCallback = function(companyId, groupId) {
            var staffReq = $http({
                    method: 'POST',
                    url: staffUrl.replace('{companyId}', companyId),
                    data: {
                        'expand': 'code,name,contactView.isStaffCenterEnabled,contactView.id',
                        'excludeCount': true,
                        'filterSearchSort': {
                          'orderBy': 'code asc',
                          'search': '',
                          'searchBy': 'code,name',
                          'filter': ''
                        },
                        'pagingDataRequest': {
                          'startIndex': 1,
                          'pageIndex': 0,
                          'itemsPerPage': 1000
                        }
                      }
                }),
                membersReq = $http({
                    url: membersUrl.replace('{groupId}', groupId)
                }),
                reqs = $q.all([staffReq, membersReq]),
                memberIdMap = {};

            // build map for fast lookups
            membersReq.then(function(resp) {
                resp.data.members.forEach(function(item) {
                    memberIdMap[item.subjectId] = true;
                });
            });

            reqs.then(function(resps) {
                var totalPages = resps[0].data.totalPages;
                var staff = resps[0].data.items;
                if (totalPages === 1) {
                    self.clearStaff();
                    staff.forEach(function(item) {
                        // onvio center enabled staff only!
                        if (item.contactView.isStaffCenterEnabled) {
                            // is a member?
                            item.__isMember = memberIdMap[item.contactView.id] !== undefined;
                            self.staff.push(item);
                        }
                    });
                } else {
                    for (var i = 1; i < totalPages; i++) {
                        var staffreq2 = $http({
                            method: 'POST',
                            url: staffUrl.replace('{companyId}', companyId),
                            data: {
                                'expand': 'code,name,contactView.isStaffCenterEnabled,contactView.id',
                                'excludeCount': true,
                                'filterSearchSort': {
                                  'orderBy': 'code asc',
                                  'search': '',
                                  'searchBy': 'code,name',
                                  'filter': ''
                                },
                                'pagingDataRequest': {
                                  'startIndex': (i * 1000) + 1,
                                  'pageIndex': 0,
                                  'itemsPerPage': 1000
                                }
                              }
                        });
                        staffreq2.then(function(response) { // jshint ignore:line
                            staff = staff.concat(response.data.items);
                            self.clearStaff();
                            staff.forEach(function(item) {
                                // onvio center enabled staff only!
                                if (item.contactView.isStaffCenterEnabled) {
                                    // is a member?
                                    item.__isMember = memberIdMap[item.contactView.id] !== undefined;
                                    self.staff.push(item);
                                }
                            });
                        });
                    }
                }
            });
            return reqs;
        };
        self.loadConfidentialContacts = function(companyId) {
            return $http({
                url: confidentialContactUrl.replace('{companyId}', companyId).replace('{startIndex}', 1)
            }).then(function(resp) {
                return resp.data;
            });
        };
        self.loadFolderTemplates = function() {
            return $http({
                url: folderTemplatesUrl
            });
        };
        self.loadClients = function(companyId) {
            return $http({
                method: 'POST',
                url: clientUrl.replace('{companyId}', companyId).replace('{startIndex}', 1),
                data: {
                    'frp': '',
                    'expand': 'fullName,isClientCenterEnabled',
                    'excludeCount': true,
                    'filterSearchSort': {
                      'orderBy': 'fullName',
                      'search': '',
                      'searchBy': '',
                      'filter': '{"items":[{"by":"isClientCenterEnabled","op":"EQ","value":"true"}]}}'
                    },
                    'pagingDataRequest': {
                      'startIndex': 1,
                      'pageIndex': 0,
                      'itemsPerPage': 1000
                    }
                  }
            }).then(function(resp) {
                return resp.data;
            });
        };
        self.loadOffices = function(companyId, itemsPerPage, pageIndex) {
            return $http({
                method: 'POST',
                url: officeUrl.replace('{companyId}', companyId),
                data: {
                    'expand': 'code,contactView.displayAs,contactView.id',
                    'excludeCount': true,
                    'filterSearchSort': {
                      'orderBy': 'code',
                      'search': '',
                      'searchBy': 'code,primaryContactExpanded,primaryContact.name',
                      'filter': ''
                    },
                    'pagingDataRequest': {
                      'startIndex': 0,
                      'pageIndex': pageIndex,
                      'itemsPerPage': itemsPerPage
                    }
                  }
            }).then(function(resp){
                return resp.data;
            });
        };
        self.loadActiveEmployees = function(companyId, itemsPerPage, pageIndex) {
            return $http({
                method: 'POST',
                url: employeeUrl.replace('{companyId}', companyId),
                data: {
                    'expand': 'code,name,contactView.isStaffCenterEnabled,contactView.id,departmentNames,contactView.displayAs',
                    'excludeCount': true,
                    'filterSearchSort': {
                      'orderBy': 'code asc',
                      'search': '',
                      'searchBy': 'code,name',
                      'filter': ''
                    },
                    'pagingDataRequest': {
                      'startIndex': 0,
                      'pageIndex': pageIndex,
                      'itemsPerPage': itemsPerPage
                    }
                  }
            }).then(function(resp){
                return resp.data;
            });
        };

        self.save = function(method, filters, group, perms, members) {
            var aggData = {};
            var groupId = method === 'PUT' ? group.subjectGroupId.toLowerCase()
                .replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w*)/, '$1-$2-$3-$4-$5')
                : null;
            var url = (method === 'PUT') ? grpPermMemPostPutUrl.replace('{groupId}', groupId) :
                grpPermMemPostPutUrl.replace('/{groupId}', '');

            aggData.id = groupId;
            aggData.name = group.name;
            aggData.description = group.description;
            aggData.subjectGroupTypeId  = method === 'PUT' ? group.subjectGroupTypeId : SUBJECT_GROUP_TYPE_ID;

            aggData.permissions = getPermsSaveData(perms);
            aggData.members = { members: getMembersSaveData(members) }; // yep double members
            aggData.filters = filters;

            return $http({
                url: url,
                method: method,
                data: aggData
            });
        };

        self.saveGranularPerm = function(group, subjectGroupId) {
            return $http({
                url: grpPermDataUrl + subjectGroupId,
                data:group,
                method: 'PUT'
            });
        };
        self.createGranularPerm = function(group) {
            return $http({
                url: grpPermDataUrl,
                data:group,
                method: 'POST'
            });
        };

        self.getGroupHistory = function(subjectGroupId) {
            return $http({
                url: grpPermAuditEventsUrl.replace('{groupId}', subjectGroupId.toLowerCase().replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w*)/, '$1-$2-$3-$4-$5')),
                method: 'GET'
            });
        };
        function getPermsSaveData(perms) {
            var permsCopy = angular.copy(perms);

            // filter to just visited nodes; todo: just dirty nodes
            permsCopy = permsCopy.filter(function(permNode) {
                return !!permNode.type;
            });

            // clean up parent pointers to elim circular structure errors on stringify
            permsCopy.forEach(function(permNode) {
                visit(permNode, removeParentPointers);
            });

            return permsCopy;
        }

        self.savePerms = function(groupId, perms) {
            return $http({
                url: permDetailPostUrl.replace('{groupId}', groupId),
                method: 'POST',
                data: { permissions: getPermsSaveData(perms) }
            });

            // return perms.map(function(permNode) {
            //     if (permNode.type) {
            //         // todo: only save if dirty

            //         // clean up parent pointers to elim circular structure errors on stringify
            //         visit(permNode, removeParentPointers);

            //         return $http({
            //             url: permDetailPostUrl.replace('{groupId}', groupId),
            //             method: 'POST',
            //             data: permNode
            //         });
            //     }
            // });
        };

        function getMembersSaveData(staff) {
            var membersSaveData = [];

            staff.forEach(function(item) {
                if (item.__isMember) {
                    membersSaveData.push({ subjectId: item.contactView.id });
                }
            });

            return membersSaveData;
        }

        self.getMembers = function(groupId) {
            var url = membersUrl.replace('{groupId}', groupId);
            var req = $http.get(url).then(function(resp) {
                return resp.data.members;
            });

            return req;
        };

        //asssumes contactIds are staff center enabled
        self.saveMembers = function(groupId, contactIds) {
            var url =  membersUrl.replace('{groupId}', groupId);
            var data = { members: contactIds.map(function(id) { return { subjectId: id }; })};
            return $http.put(url, data);
        };

        /*
        //returns a list of the contactIds filtered to include only contacts that have staff center enabled
        function filterByStaffCenterEnabledContacts(companyId, contactIds) {
            if(contactIds.length === 0) {
                return $q.resolve([]);
            }

            var contactsViewUrl = staffEnabledContactsFilterUrl.replace('{companyId}', companyId);
            contactsViewUrl = contactsViewUrl.replace('{contactIds}', contactIds.join());

            var req = $http.get(contactsViewUrl).then(function(resp) {
                return resp.data.items.map(function(item) {
                    return item.id;
                });
            });

            return req;
        }
        */

        self.destroy = function(delList) {
            var promises = [], delItemIdxs = [], allPromises;
            delList.forEach(function(delGrp) {
                var delIdx = self.list.indexOf(delGrp);
                if (delIdx >= 0) {
                    var groupId = delGrp.subjectGroupId.toLowerCase().replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w*)/, '$1-$2-$3-$4-$5');
                    var deletePermPromise = $http({
                        url: grpPermMemPostPutUrl.replace('{groupId}', groupId),
                        method: 'DELETE'
                    });

                    deletePermPromise.then(function() {
                        delItemIdxs.push(delIdx);
                    });
                    promises.push(deletePermPromise);
                }
            });

            allPromises = $q.all(promises);

            allPromises.finally(function() {
                delItemIdxs.forEach(function(idx) {
                    self.list.splice(idx, 1);
                });
            });

            return allPromises;
        };

        self.deleteGroups = function(delList) {
            var promises = [];
            delList.forEach(function(delGrp){
                var groupId = delGrp.subjectGroupId.toLowerCase().replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w*)/, '$1-$2-$3-$4-$5');
                var deletePermPromise = $http({
                    url: grpPermMemPostPutUrl.replace('{groupId}', groupId),
                    method: 'DELETE'
                });
                promises.push(deletePermPromise);
            });
            return $q.all(promises);
        };

        function visit(node, fn) {
            if (!fn) { return node; }
            fn(node);
            if (node.children) {
                node.children.forEach(function(child) {
                    visit(child, fn);
                });
            }
            return node;
        }

        function addParentPointers(node) {
            if (node.children) {
                node.children.forEach(function(child) {
                    child.parent = node;
                });
            }
        }

        function removeParentPointers(node) {
            if (node.children) {
                node.children.forEach(function(child) {
                    delete child.parent;
                });
            }
        }
        self.getPreference = function(application, category, contactId) {
            var url = preferenceUrl.replace('{application}', application).replace('{category}', category).replace('{contactId}', contactId);
            return $http.get(url).then(function(resp){
                return resp.data;
            }).catch(function(resp){
                /* suppress error on valid 404 */
                if(resp.status === 404){
                    resp.config.global = false;
                    console.log('GET 404 (Not Found) for permission help preference is a valid response, no need for concern.');
                    return $q.resolve([{preferences: {isVisible: true}}]);
                }
            });
        };
        self.updatePreference = function(application, category, contactId, preference) {
            var url = preferenceUrl.replace('{application}', application).replace('{category}', category).replace('{contactId}', contactId);
            return $http.put(url, preference);
        };
        self.deletePreference = function(preferenceId) {
            var url = '/api/profiles/v1/preferences/' + preferenceId;
            return $http.delete(url);
        };
        self.getCompanyMain = function(companyId) {
            var url = companyMainUrl.replace('{companyId}', companyId);
            return $http.get(url);
        };
        function getGroupPermsCompareFn(locale) {
            if (locale) {
                locale = locale.split('-')[0];
            }
            return function(a, b) {
                var result = 0;
                if (angular.isDefined(a.displayOrder) && angular.isDefined(b.displayOrder)) {
                    result = b.displayOrder - a.displayOrder;
                }
                if (result === 0) {
                    result = a.displayName.localeCompare(b.displayName, locale || undefined);
                }
                return result;
            };
        }

        /* INIT */
        init();
    }

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bm.permissiongroups.uniquePermissionGroupNameAsyncValidator', ['bm.permissiongroups.PermissionGroupsService'])
        .directive('bmUniquePermissionGroupName', uniquePermissionGroupNameAsyncValidator);

    uniquePermissionGroupNameAsyncValidator.$inject = ['$q', 'bm.permissiongroups.PermissionGroupsService' ];

    function uniquePermissionGroupNameAsyncValidator($q, permGroupsService) {
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {
                var origModelValue;

                ctrl.$asyncValidators.bmUniquePermissionGroupName = function(modelValue, viewValue) {
                    if (ctrl.$pristine || modelValue === origModelValue) {
                        // consider pristine view and unchanged model scenarios valid
                        origModelValue = modelValue;
                        return $q.when();
                    }

                    var def = $q.defer();

                    permGroupsService.isGroupNameUnique(viewValue).then(function(isUnique) {
                        if (isUnique) {
                            def.resolve();
                        } else {
                            def.reject();
                        }
                    }, function() {
                        def.reject();
                    });

                    return def.promise;
                };
            }
        };
    }

}(window.angular));

(function(angular){
    'use strict';

    angular
    .module('bm.permissiongroups.PermissionGroupsPicker',
            [
                'bm-permission-groups.component.templates',
                'nucleusPermissionsForm',
                'bm.permissiongroups.PermissionGroupsService',
                'bluemoon.components.session'
            ])
    .component('permissionGroupsPicker', {
        bindings: {
            contact: '<'
        },
        controller: PermissionGroupsPickerController,
        templateUrl: 'components/permission-groups-picker/export/permission-groups-picker.html'
    });

    PermissionGroupsPickerController.$inject = ['$scope', '$http', '$q', 'bm.permissiongroups.PermissionGroupsService', 'AuthenticatedSessionData', 'bmPermission', 'bmAccess'];
    function PermissionGroupsPickerController($scope, $http, $q, groupsService, session, bmPermission, bmAccess){
        var ctrl = this;
        ctrl.allGroups = [];
        ctrl.currSelectedGroups = [];
        ctrl.prevSelectedGroups = [];

        ctrl.mergedPerms = [];
        ctrl.currSelectedPerm = undefined;

        ctrl.companyId = undefined;

        ctrl.showBusyLoader = false;

        ctrl.$onChanges = init;
        ctrl.onMultiselectDone = onDone;

        // Validation for not selecting any group
        ctrl.mustHaveAccessToOneOrMoreGroups = function HasAccessToOneOrMoreGroups(){
            return ctrl.currSelectedGroups.length > 0;
        };

        function init(changes) {
            if(changes.contact.currentValue.id === undefined) { return; }

            $q.all([
                loadGroups(),
                loadPermissions()
            ]);

            session.getBindings().then(function(data) {
                ctrl.companyId = data.ApplicationConfiguration.CompanyId;
            });

            // quick fix until we get rid of this completely
            bmPermission.not('Platform.GranularPermissions').then(function(){
                $scope.$on('nucleus-permissions-form-tab-select', function(evt, node) {
                    groupsService.loadContactsPermDetails(node, [ctrl.contact.id]);
                });
            });

            ctrl.granPermsDisabled = false;
            bmAccess.has('Platform_DisablePermissionUpdates').then(function() {
                ctrl.granPermsDisabled = true;
            }).catch(function(){
                ctrl.granPermsDisabled = false;
            });
        }

        function loadGroups() {
            var prom = $q.all([
                groupsService.loadGroupList(false).then(function() {
                    ctrl.allGroups = groupsService.list.map(function(group) {
                        return { name: group.name, subjectGroupId: group.subjectGroupId };
                    }).sort(function(g1, g2) { return g1.name.localeCompare(g2.name); });
                }),
                groupsService.getContactsGroupList([ctrl.contact.id]).then(function(groups) {
                    return fillSet(groups.map(function(group) {
                        return group.subjectGroupId;
                    }));
                })
            ]).then(function(resps) {
                ctrl.currSelectedGroups = ctrl.allGroups.filter(function(group) {
                    return resps[1].has(group.subjectGroupId);
                });

                //clone curr selected to save it
                ctrl.prevSelectedGroups = JSON.parse(JSON.stringify(ctrl.currSelectedGroups));
            });

            return prom;
        }

        function fillSet(lst) {
            //because ie11 sucks
            var s = new Set();
            lst.forEach(function(i) { s.add(i); });
            return s;
        }

        function loadPermissions() {
            var prom = groupsService.loadGroupPerms('valDoesntMatter').then(function() {
                ctrl.mergedPerms = groupsService.groupPerms;
            });
            return prom;
        }

        function onDone(newlySelectedGroups) {
            //ctrl.currSelectedGroups is autoupdated bento picker

            ctrl.showBusyLoader = true;
            //workaround because bento retunrs undefined if nothing is picked in the list
            if (newlySelectedGroups === undefined) {
                newlySelectedGroups = [];
            }
            var curr = fillSet(ctrl.prevSelectedGroups.map(function(g) { return g.subjectGroupId; }));
            var next = fillSet(newlySelectedGroups.map(function(g) { return g.subjectGroupId; }));

            replaceStaffMembersGroups(ctrl.contact.id, curr, next).then(function() {
                //currently reloads all tabs
                //how to get currently selected tab to reload that and lazy load others??
                $q.all(ctrl.mergedPerms.map(function(node) {
                    return groupsService.loadContactsPermDetails(node, [ctrl.contact.id]);
                })).then(function() {
                    ctrl.showBusyLoader = false;
                });

                //workaround because bento retunrs undefined if nothing is picked in the list
                if (ctrl.currSelectedGroups === undefined) {
                    ctrl.currSelectedGroups = [];
                }

                //saves clone of current selection
                ctrl.prevSelectedGroups = JSON.parse(JSON.stringify(ctrl.currSelectedGroups));
            });

            //replaces the old groups of a staff user identified by their contactId with new groups
            function replaceStaffMembersGroups(contactId, oldGroups, newGroups){
                return $q.all(transformUpdatedGroups(oldGroups, newGroups));

                function transformUpdatedGroups(oldGroups, newGroups) {
                    return addedGroups(oldGroups, newGroups).map(function(groupId) {
                        return transformGroupMembers(groupId, contactId, addMember);
                    }).concat(removedGroups(oldGroups, newGroups).map(function(groupId) {
                        return transformGroupMembers(groupId, contactId, removeMember);
                    }));
                }

                function addedGroups(oldGroups, newGroups) {
                    return relComplement(newGroups, oldGroups);
                }

                function removedGroups(currentGroups, newGroups)    {
                    return relComplement(currentGroups, newGroups);
                }

                //https://en.wikipedia.org/wiki/Complement_(set_theory)#Relative_complement
                function relComplement(set1, set2) {
                    var l = [];
                    set1.forEach(function(elt) { l.push(elt); });

                    return l.filter(function(id) {
                        return !set2.has(id);
                    });
                }

                function transformGroupMembers(groupId, contactId, transformMembersFunc) {
                    var req = groupsService.getMembers(groupId).then(function(members) {
                        var membersContactIds = members.map(function(member) {
                            return member.subjectId;
                        });

                        return groupsService
                            .saveMembers(groupId, transformMembersFunc(membersContactIds, contactId));
                    });

                    return req;
                }

                function addMember(members, contactId) {
                    return members.concat([contactId]);
                }

                function removeMember(members, contactId) {
                    return members.filter(function(_contactId) { return _contactId !== contactId; });
                }
            }
        }
    }
})(window.angular);


(function(angular){
    'use strict';

    angular
    .module('bmPermissionGroupsPicker',
            [
                'bm-permission-groups.component.templates',
                'nucleusPermissionsForm',
                'bm.permissiongroups.PermissionGroupsService',
                'bluemoon.components.session'
            ])
    .component('bmPermissionGroupsPicker', {
        bindings: {
            contact: '<'
        },
        controller: bmPermissionGroupsPickerController,
        templateUrl: 'components/permission-groups-picker/export/bm-permission-groups-picker.html'
    });

    bmPermissionGroupsPickerController.$inject = ['$scope', '$http', '$q', 'bm.permissiongroups.PermissionGroupsService', 'AuthenticatedSessionData', '$translate', 'helpService', 'bmAccess'];
    function bmPermissionGroupsPickerController($scope, $http, $q, groupsService, session, $translate, helpService, bmAccess){
        /*jshint validthis:true */
        var ctrl = this;
        ctrl.allGroups = [];
        ctrl.currSelectedGroups = [];
        ctrl.prevSelectedGroups = [];

        ctrl.selectedGroupPerms = [];
        ctrl.currSelectedPerm = undefined;

        ctrl.companyId = undefined;

        ctrl.showBusyLoader = false;
        ctrl.$onChanges = init;
        ctrl.toggleGroup = toggleGroup;

        // Validation for not selecting any group
        ctrl.mustHaveAccessToOneOrMoreGroups = function HasAccessToOneOrMoreGroups(){
            return ctrl.allGroups.filter(function(group) {return group.selected;}).length > 0;
        };

        ctrl.granPermsDisabled = false;
        bmAccess.has('Platform_DisablePermissionUpdates').then(function() {
            ctrl.granPermsDisabled = true;
        }).catch(function(){
            ctrl.granPermsDisabled = false;
        });

        function init(changes) {
            if(changes.contact.currentValue.id === undefined || changes.contact.currentValue.givenName === undefined) { return; }

            loadGroups();

            $translate('Bluemoon.Core.Setup.Groups.SetFunctionality.Title').then(function(val){
                ctrl.functionalityHeading = val;
            });
            $translate('Bluemoon.Core.Setup.Groups.ClientData.Title').then(function(val){
                ctrl.dataHeading = val;
            });
            $translate('Bluemoon.Core.Setup.Groups.SelectForStaff', { staffUser: changes.contact.currentValue.givenName }).then(function(val){
                ctrl.selectForStaffText = val;
            });

            session.getBindings().then(function(data) {
                ctrl.companyId = data.ApplicationConfiguration.CompanyId;
            });
            helpService.load().then(function(resp) {
                ctrl.interactionHelpLink = resp.data.baseUrl + 'how-permissions-interact.htm';
            });

            $scope.$watch('$ctrl.selectedGroup', function() {
                if(ctrl.selectedGroup) {
                    loadPermissions(ctrl.selectedGroup.subjectGroupId);
                    loadPermissionData(ctrl.selectedGroup.subjectGroupId);
                }
            });

            $scope.$on('nucleus-permissions-form-tab-select', function(evt, node) {
                groupsService.loadGroupPermDetails(node);
            });
            $scope.$on('bm-groups-save', function() {
                saveGroups();
            });
        }
        function saveGroups() {
            var selectedGroups = ctrl.allGroups.filter(function(group){{ return group.selected; }});
            var unselectedGroups = ctrl.allGroups.filter(function(group){ return !group.selected; });
            // if newly selected group, add user to that group
            var newlySelectedGroups = selectedGroups.filter(function(group){ return !ctrl.prevSelectedGroups.includes(group.subjectGroupId); });
            addUserToGroups(newlySelectedGroups);
            // if newly unselected group, remove user from that group
            var newlyRemovedGroups = unselectedGroups.filter(function(group){ return ctrl.prevSelectedGroups.includes(group.subjectGroupId); });
            removeUserFromGroups(newlyRemovedGroups);
        }
        function toggleGroup(group) {
            var arr = [];
            arr.push(group);
            group.selected = !group.selected;
            if(group.selected){
                addUserToGroups(arr);
            } else {
                removeUserFromGroups(arr);
            }
        }
        function addUserToGroups(groups) {
            groups.forEach(function(group){
                groupsService.getMembers(group.subjectGroupId).then(function(members){
                    var userIndex = (members.map(function(member){ return member.subjectId; }).indexOf(ctrl.contact.id));
                    if(userIndex === -1){
                        members.push({ subjectGroupId: group.subjectGroupId, subjectId: ctrl.contact.id });
                        groupsService.saveMembers(group.subjectGroupId, members.map(function(member){ return member.subjectId; }));
                    }
                });
            });
        }
        function removeUserFromGroups(groups) {
            groups.forEach(function(group){
                groupsService.getMembers(group.subjectGroupId).then(function(members){
                    var userIndex = (members.map(function(member){ return member.subjectId; }).indexOf(ctrl.contact.id));
                    if(userIndex > -1){
                        members.splice(userIndex, 1);
                        groupsService.saveMembers(group.subjectGroupId, members.map(function(member){ return member.subjectId; }));
                    }
                });
            });
        }
        function loadGroups() {
            $q.all([
                groupsService.loadSubjectGroups(),
                groupsService.loadPermGrps(),
                groupsService.getContactsGroups([ctrl.contact.id])
            ]).then(function(resps){
                ctrl.allGroups = resps[0].data.dtos.map(function(group) {
                    return { name: group.name, description: group.description, subjectGroupId: group.subjectGroupId };
                }).sort(function(g1, g2) { return g1.name.localeCompare(g2.name); });
                ctrl.selectedGroup = ctrl.allGroups[0];
                ctrl.currSelectedGroups = resps[2].data.dtos.map(function(group){return group.subjectGroupId;});
                if(resps[1].data) {
                    var systemGroups = resps[1].data.filter(function(group){ return groupsService.isSystemGroup(group.permissionGroupType);});
                    systemGroups.forEach(function(systemGroup) {
                        ctrl.allGroups = ctrl.allGroups.map(function(subjectGroup) {
                            if (subjectGroup.subjectGroupId.toLowerCase().replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w*)/, '$1-$2-$3-$4-$5') === systemGroup.id) {
                                subjectGroup.permissionGroupType =  systemGroup.permissionGroupType;
                                subjectGroup.system = true;
                            }
                            return subjectGroup;
                        });
                    });
                }
                ctrl.allGroups.map(function(group){
                    group.selected = ctrl.currSelectedGroups.includes(group.subjectGroupId);
                });
                //clone curr selected to save it
                ctrl.prevSelectedGroups = ctrl.currSelectedGroups;
            });
        }

        function loadPermissions(groupId) {
            ctrl.selectedGroupPerms = [];
            groupsService.loadGroupPermsTabs(groupId).then(function() {
                ctrl.selectedGroupPerms = groupsService.groupPerms;
            });
        }
        /* TODO: do this on Data tab select */
        function loadPermissionData(groupId) {
            var prom = groupsService.loadGroupFilters(groupId.toLowerCase().replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w*)/, '$1-$2-$3-$4-$5')).then(function(data) {
                if(data) {ctrl.selectedGroupPermsData = data;}
            });
            return prom;
        }
    }
})(window.angular);


/*
 * Permission Groups Data Component
*/
(function(angular){
	'use strict';

	angular.module('bmPermissionGroupsEquation', [ 'bm-permission-groups.component.templates'] )
		.component('bmPermissionGroupsEquation', {
			templateUrl: 'components/permission-groups-equation/export/permission-groups-equation.html',
			controller: PermissionGroupsEquationCtrl,
			controllerAs: 'vm'
		});
	PermissionGroupsEquationCtrl.$inject = ['AuthenticatedSessionData', '$location', '$scope', 'helpService', 'bm.permissiongroups.PermissionGroupsService'];

	function PermissionGroupsEquationCtrl (session, $location, $scope, helpService, groupsService) {
        /*jshint validthis:true */
        var vm = this;
		vm.toggleVisibility = toggleVisibility;
        vm.$onInit = function() {
			vm.isVisible = false;
			helpService.load().then(function(resp) {
				vm.bestPracticesUrl = resp.data.baseUrl + 'permissions-best-practices.htm';
				vm.helpInteractionsUrl = resp.data.baseUrl + 'how-permissions-interact.htm';
			});
			session.getBindings().then(function(data) {
				groupsService.getPreference('StaffApplication', 'permissionEquation', data.ApplicationConfiguration.ContactId).then(function(resp) {
					if(resp.length > 0){
						vm.isVisible = JSON.parse(resp[0].preferences).isVisible;
					}
				}).catch(function(){
					vm.isVisible = true;
				});
			});
        };
		$scope.$on('bm-equation-visibility-toggle', function(){
			toggleVisibility();
		});
		function toggleVisibility() {
			vm.isVisible = !vm.isVisible;
			session.getBindings().then(function(data) {
				groupsService.updatePreference('StaffApplication', 'permissionEquation', data.ApplicationConfiguration.ContactId, { preferences: JSON.stringify({isVisible: vm.isVisible}) } );
			});
		}

	}
})(window.angular);

/*
 * Permission Groups Data Component
*/
(function(angular){
	'use strict';

	angular.module('bmPermissionGroupsDropdown', [ 'bm-permission-groups.component.templates'] )
		.component('bmPermissionGroupsDropdown', {
			templateUrl: 'components/permission-groups-dropdown/export/permission-groups-dropdown.html',
			controller: PermissionGroupsDropdownCtrl,
			bindings: {
				type: '@'
			}
		});
	PermissionGroupsDropdownCtrl.$inject = ['AuthenticatedSessionData', 'bm.permissiongroups.PermissionGroupsService', '$translate'];

	function PermissionGroupsDropdownCtrl (session, groupsService, $translate) {
        /*jshint validthis:true */
		var ctrl = this;

		ctrl.getItems = getItems;
        ctrl.$onInit = function() {
			ctrl.readOnly = false;
			ctrl.pageIndex = 0;
			ctrl.itemsPerPage = 25;
			ctrl.dropdownData = null;
			getDataForType(ctrl.type);
		};

		function getDataForType(type) {
			var translateLabel;
			var dataService;
			var relativeItem;
			session.getBindings().then(function(data) {
				switch(type) {
					case 'client_office':
						relativeItem = {displayName: ctrl.relativeOffice, referenceId: '$assignedOffice'};
						translateLabel = $translate('Bluemoon.Core.Setup.Groups.ClientData.ClientOfficeMatches');
						dataService = groupsService.loadOffices(data.ApplicationConfiguration.CompanyId, ctrl.itemsPerPage, ctrl.pageIndex);
						break;
					case 'client_partner':
						relativeItem = {displayName: ctrl.relativeName, referenceId: '$thisGroupMember'};
						translateLabel = $translate('Bluemoon.Core.Setup.Groups.ClientData.ClientPartnerMatches');
						dataService = groupsService.loadActiveEmployees(data.ApplicationConfiguration.CompanyId, ctrl.itemsPerPage, ctrl.pageIndex);
						break;
					case 'client_manager':
						relativeItem = {displayName: ctrl.relativeName, referenceId: '$thisGroupMember'};
						translateLabel = $translate('Bluemoon.Core.Setup.Groups.ClientData.ClientManagerMatches');
						dataService = groupsService.loadActiveEmployees(data.ApplicationConfiguration.CompanyId, ctrl.itemsPerPage, ctrl.pageIndex);
						break;
					case 'client_associate':
						relativeItem = {displayName: ctrl.relativeName, referenceId: '$thisGroupMember'};
						translateLabel = $translate('Bluemoon.Core.Setup.Groups.ClientData.ClientAssociateMatches');
						dataService = groupsService.loadActiveEmployees(data.ApplicationConfiguration.CompanyId, ctrl.itemsPerPage, ctrl.pageIndex);
						break;
					case 'staff_office':
						relativeItem = {displayName: ctrl.relativeOffice, referenceId: '$assignedOffice'};
						translateLabel = $translate('Bluemoon.Core.Setup.Groups.Data.StaffOfficeMatches');
						dataService = groupsService.loadOffices(data.ApplicationConfiguration.CompanyId, ctrl.itemsPerPage, ctrl.pageIndex);
						break;
					case 'staff_department':
						relativeItem = {displayName: ctrl.relativeName, referenceId: '$thisGroupMember'};
						translateLabel = $translate('Bluemoon.Core.Setup.Groups.Data.StaffDepartmentMatches');
						dataService = groupsService.loadActiveEmployees(data.ApplicationConfiguration.CompanyId, ctrl.itemsPerPage, ctrl.pageIndex);
						break;
					case 'staff_supervisor':
						relativeItem = {displayName: ctrl.relativeName, referenceId: '$thisGroupMember'};
						translateLabel = $translate('Bluemoon.Core.Setup.Groups.Data.StaffSupervisorMatches');
						dataService = groupsService.loadActiveEmployees(data.ApplicationConfiguration.CompanyId, ctrl.itemsPerPage, ctrl.pageIndex);
						break;
					case 'staff_level':
						relativeItem = {displayName: ctrl.relativeName, referenceId: '$thisGroupMember'};
						translateLabel = $translate('Bluemoon.Core.Setup.Groups.Data.StaffLevelMatches');
						dataService = groupsService.loadActiveEmployees(data.ApplicationConfiguration.CompanyId, ctrl.itemsPerPage, ctrl.pageIndex);
						break;
				}
				translateLabel.then(function(value){
					ctrl.dropdownData = {
						relativeItem: relativeItem,
						itemService: dataService,
						dropdownLabel: value
					};
				});
			});
		}

		function getItems() {
			ctrl.pageIndex++;
			if(!ctrl.totalPages || ctrl.pageIndex <= ctrl.totalPages) {
				return ctrl.dropdownData.itemService.then(function(resp){
					ctrl.totalPages = resp.totalPages;
					var items = resp.items.map(function(item) { return { displayName: item.contactView.displayAs, referenceId: item.contactView.id };});
					items.unshift(ctrl.relativeItem);
					return items;
				});
			}
		}
	}
})(window.angular);

/*
 * Permission Groups Members Component
*/
(function(angular){
	'use strict';

	angular.module('bmPermissionGroupsMembers', ['bm-permission-groups.component.templates'])
		.component('bmPermissionGroupsMembers', {
			templateUrl: 'components/permission-groups-members/export/permission-groups-members.html',
			controller: PermissionGroupsMembersCtrl,
			bindings: {
				staff: '<',
				onMembersChange: '&',
                groupName: '<',
                groupType: '<'
			}
		});
	PermissionGroupsMembersCtrl.$inject = [
		'AuthenticatedSessionData',
		'$translate',
        '$q',
		'$scope',
		'$filter',
        '$uibModal'
	];

	function PermissionGroupsMembersCtrl (
		session,
		$translate,
        $q,
		$scope,
		$filter,
        $uibModal
	) {
		/*jshint validthis:true */
		var ctrl = this;
        ctrl.toggleFilters = toggleFilters;
        ctrl.updateMembers = updateMembers;
        ctrl.groupPanelHidden = true;
        ctrl.filtersHidden = true;
        ctrl.selectedMembers = [];

        ctrl.$onInit = function() {
            translateJsStrings().then(function(){
                ctrl.membersGridColumns = [
                    {
                        binding: 'name',
                        header: ctrl.staffNameColumn,
                        width: '*',
                        filterType: 'input',
                        filterText: undefined
                    },
                    {
                        binding: 'code',
                        header: ctrl.staffIdColumn,
                        width: '*',
                        filterType: 'input',
                        filterText: undefined
                    },
                    {
                        binding: 'department',
                        header: ctrl.staffDepartmentColumn,
                        width: '*',
                        filterType: 'input',
                        filterText: undefined
                    }
                ];
            });
            ctrl.membersToolbarBtn = [
                {
                    id: 'bm-perm-grp-members-grid-add',
                    icon  : 'bento-icon-add',
                    action: function() {
                        /* Launch Modal to add Staff */
                        var staffModalInstance = $uibModal.open({
                            templateUrl: 'components/permission-groups-members/export/permission-groups-staff-modal.html',
                            controller: 'bmPermissionGroupsStaffModalCtrl',
                            controllerAs: 'ctrl',
                            resolve: {
                                staff: function() {
                                    return ctrl.staff;
                                }
                            },
                            windowClass: 'modal-full-height'
                        });

                        staffModalInstance.result.then(function() {
                            filterMembers();
                        }, function() {
                            filterMembers();
                        });
                    }
                },
                {
                    id: 'bm-perm-grp-members-grid-remove',
                    icon  : 'bento-icon-remove',
                    action: function() {
                        var modalInstance = $uibModal.open({
                            templateUrl: 'components/permission-groups-members/export/remove-members-confirmation-modal.html',
                            controller: ['$scope', '$uibModalInstance', 'confirmationTranslation', function ($scope, $uibModalInstance, confirmationTranslation) {
                                $scope.confirmationTranslation = confirmationTranslation;
                                $scope.save = function () {
                                    $uibModalInstance.close();
                                };
                                $scope.cancel = function () {
                                    $uibModalInstance.dismiss();
                                };
                            }],
                            resolve: {
                                confirmationTranslation: function() {
                                    return ctrl.confirmationTranslation;
                                }
                            }
                        });
                        modalInstance.result.then(function() {
                            ctrl.selectedMembers.forEach(function(item) {
                                item.selected = false;
                                item.__isMember = false;
                            });
                            filterMembers();
                        }).catch(function() {
                            filterMembers();
                        });
                    }
                }
            ];
        };

		ctrl.$onChanges = function(changes) {
			if(changes.staff) {
				ctrl.staff = changes.staff.currentValue;
				filterMembers();
			}
            ctrl.staffLoaded = true;
		};
        $scope.$on('wizardDone', function() {
            ctrl.onMembersChange({
                $event: {
                    members: ctrl.staff.filter(function(staff) {return staff.__isMember;})
                }
            });
        });

        ctrl.membersFilterOptions = {
            filterText: '',
        };

        $scope.$watch('$ctrl.membersFilterOptions.filterText', function() {
            filterMembers();
        });

        function toggleFilters(value) {
            ctrl.filtersHidden = value ? value : !ctrl.filtersHidden;
        }
        function containsString(target, value) {
            return target.toLowerCase().indexOf(value.toLowerCase()) >= 0;
        }
        function updateMembers($event) {
            ctrl.selectedMembers = $event.selectedItems;
        }
        function filterMembers() {
            var value = ctrl.membersFilterOptions.filterText;
            ctrl.filteredMembers = $filter('filter')(ctrl.staff, function(item) {
                return item.__isMember && (containsString(item.name, value) || containsString(item.code, value));
            });
        }

        function translateJsStrings() {
            return $q.all([
                $translate('Bluemoon.Core.Setup.Groups.MemberGrid.Name'),
                $translate('Bluemoon.Core.Setup.Groups.MemberGrid.StaffId'),
                $translate('Bluemoon.Core.Setup.Groups.MemberGrid.Department'),
                $translate('Bluemoon.Core.Setup.Groups.SetMembers.Remove'),
                $translate('Bluemoon.Core.Setup.Groups.Add'),
                $translate('Bluemoon.Core.Setup.Groups.RemoveModal.AreYouSure', {permissionGroup: ctrl.groupName}),
                $translate('Bluemoon.Core.Setup.Groups.MemberGrid.ShowFilters'),
                $translate('Bluemoon.Core.Setup.Groups.MemberGrid.ShowGroupPanel')
            ]).then(function(values){
                ctrl.staffNameColumn = values[0];
                ctrl.staffIdColumn = values[1];
                ctrl.staffDepartmentColumn = values[2];
                ctrl.membersToolbarBtn[1].label = values[3];
                ctrl.membersToolbarBtn[0].label = values[4];
                ctrl.confirmationTranslation = values[5];
                ctrl.showFilters = values[6];
                ctrl.showGroupPanel = values[7];
            });
        }
	}
})(window.angular);

/*
 * Permission Groups Members Grid Component
*/
(function(angular){
	'use strict';

	angular.module('bmPermissionGroupsMembersGrid', ['bm-permission-groups.component.templates'])
		.component('bmPermissionGroupsMembersGrid', {
			templateUrl: 'components/permission-groups-members/export/permission-groups-members-grid.html',
			controller: PermisisonGroupsMembersGridCtrl,
			bindings: {
				toolbar: '<',
                gridData: '<',
                groupType: '<',
                groupName: '<',
				columns: '<',
				filtersHidden: '<',
				groupPanelHidden: '<',
				onSelectedItemsChange:'&'
			}
		});

	PermisisonGroupsMembersGridCtrl.$inject = ['$scope', '$translate'];

	function PermisisonGroupsMembersGridCtrl($scope, $translate) {

        var ctrl = this;
        var filterTimeout;
        ctrl.updateFilter = updateFilter;
		ctrl.onCheckboxChange = onCheckboxChange;
        ctrl.onHeaderCheckboxChange = onHeaderCheckboxChange;
        ctrl.selectedItems = [];
        ctrl.allItemsSelected = false;

		ctrl.$onChanges = function(changes) {
			if(changes.gridData) {
				ctrl.gridCollectionView = new wijmo.collections.CollectionView(changes.gridData.currentValue, {filter: customCollectionViewFilter}); // jshint ignore:line
			}
			if(changes.filtersHidden) {
				toggleFilterVisibility(changes.filtersHidden.currentValue);
			}
            $translate('Bluemoon.Practice.Common.Grid.GroupPanel.Placeholder').then(function(str) {
                ctrl.groupsPlaceholder = str;
            });
		};
        $scope.$watchCollection('$ctrl.selectedItems', function() {
			updateHeaderCheckbox();
        });
        $scope.$watch(function() {
            return ctrl.gridCtrl;
        }, function(grid) {
			initializeGrid(grid);
        });
        function initializeGrid(grid) {
			ctrl.gridInitialized = false;
            if (grid) {
                //Add new column header row for filters
                var row = new wijmo.grid.Row(); // jshint ignore:line
                var column = new wijmo.grid.Column(); // jshint ignore:line
                grid.rowHeaders.columns.insert(1, column);
                grid.columnHeaders.rows.insert(1, row);
                grid.columnHeaders.rows[1].height = 0;
                //Set up collection view filter
                grid.collectionView.filter = customCollectionViewFilter;
            }
            const gridEdit = document.querySelector('[wj-part="rh"]');
            gridEdit.setAttribute('aria-hidden', 'false');
            const selectAllEdit = document.querySelector('[wj-part="tl"]');
            selectAllEdit.setAttribute('aria-hidden', 'false');
			ctrl.gridInitialized = true;
        }
		function customCollectionViewFilter(item) {
			var val = null;
			var itemkey = null;
			if( ctrl.gridInitialized ){
				for (var i = 0, il = ctrl.columns.length; i < il; i++) {
					var colBind = ctrl.columns[i];
					if ('filterText' in colBind && colBind.filterText) {
						val = colBind.filterText;
						itemkey = item[colBind.binding];
					}
					if (!val) {
						continue;
					}
					val = String(val);

					if (String(itemkey).toLowerCase().indexOf(val.toLowerCase()) < 0) {
						return false;
					}
				}

				// all passed
				return true;
			}
		}
        function updateFilter(id) {
            if (ctrl.gridCtrl) {
                if (filterTimeout) { clearTimeout(filterTimeout); }
                filterTimeout = setTimeout(function() {
                    var focusedID = 'filter-' + id;
                    //var focused = document.activeElement;
                    ctrl.gridCtrl.collectionView.refresh();
                    setTimeout(function() {
                        var focused = document.getElementById(focusedID);
                        if (focused) {
                            focused.focus();
                            var strLength = focused.value.length;
                            focused.setSelectionRange(strLength, strLength);
                        }
                    }, 100);
                }, 300);
            }
        }
        function toggleFilterVisibility(value) {
            if (ctrl.gridInitialized) {
                ctrl.gridCtrl.columnHeaders.rows[1].height = value ? 0 : 56;
			}
		}
        function onHeaderCheckboxChange() {
            ctrl.allItemsSelected = !ctrl.allItemsSelected;
            ctrl.selectedItems = [];
            for (var i = 0, ttl = ctrl.gridCtrl.rows.length; i < ttl; i++) {
                ctrl.gridCtrl.rows[i].dataItem.selected = ctrl.allItemsSelected;
            }
            if(ctrl.allItemsSelected){
                ctrl.selectedItems = ctrl.gridCtrl.rows.filter(function(item){
                    if(ctrl.groupType === 'system.administrators') {
                        return !item.dataItem.isUberAdmin;
                    }
                    return true;
                }).map(function(item) { return item._data;});
            }
			ctrl.onSelectedItemsChange({$event: {
				selectedItems: ctrl.selectedItems
            }});
        }
        function onCheckboxChange() {
            ctrl.selectedItems = ctrl.gridCtrl.rows.filter(function(row){
				return row.dataItem.selected;
            }).map(function(item){
				return item._data;
            });
			ctrl.onSelectedItemsChange({$event: {
				selectedItems: ctrl.selectedItems
            }});
        }
        function updateHeaderCheckbox() {
            ctrl.allItemsSelected = false;
            var count = 0;
            if (ctrl.gridCtrl && ctrl.gridCtrl.rows.length > 0){
                for (var i = 0, ttl = ctrl.gridCtrl.rows.length; i < ttl; i++) {
                    if (ctrl.gridCtrl.rows[i].dataItem.selected === true) {
                        count++;
                    }
                }
                if (count === ctrl.gridCtrl.rows.length) {
                    ctrl.allItemsSelected = true;
                }
            }
        }
	}
})(window.angular);

/*
 * Permission Groups Members Component
*/
(function(angular){
	'use strict';

	angular.module('permissionGroupsMembers', ['bm-permission-groups.component.templates'])
		.component('permissionGroupsMembers', {
			templateUrl: 'components/bm-permission-groups-members/export/permission-groups-members.html',
			controller: PermissionGroupsMembersCtrl,
			bindings: {
				staff: '<',
				onMembersChange: '&'
			}
		});
	PermissionGroupsMembersCtrl.$inject = [
		'AuthenticatedSessionData',
		'$translate',
		'$scope',
		'$filter'
	];

	function PermissionGroupsMembersCtrl (
		session,
		$translate,
		$scope,
		$filter
	) {
		/*jshint validthis:true */
		var ctrl = this;
		ctrl.onCheckboxChange = onCheckboxChange;
        ctrl.onStaffHeaderCheckboxChange = onStaffHeaderCheckboxChange;
        ctrl.onMemberHeaderCheckboxChange = onMemberHeaderCheckboxChange;

        ctrl.allStaffSelected = false;
        ctrl.allMembersSelected = false;
        ctrl.selectedStaff = [];
        ctrl.selectedMembers = [];

		ctrl.$onChanges = function(changes) {
			if(changes.staff) {
				ctrl.staff = changes.staff.currentValue;
				filterStaff();
				filterMembers();
			}
            ctrl.staffLoaded = true;
			translateJsStrings();
		};
        $scope.$on('wizardDone', function() {
            ctrl.onMembersChange({
                $event: {
                    members: ctrl.staff.filter(function(staff) {return staff.__isMember;})
                }
            });
        });
        $scope.$watchCollection('$ctrl.selectedStaff', function() {
            ctrl.staffToolbarBtn[0].disabled = false;
            if(ctrl.selectedStaff.length === 0) {
                ctrl.staffToolbarBtn[0].disabled = true;
            }
            updateStaffHeaderCheckbox();
        });
        $scope.$watchCollection('$ctrl.selectedMembers', function() {
            ctrl.membersToolbarBtn[0].disabled = false;
            if(ctrl.selectedMembers.length === 0) {
                ctrl.membersToolbarBtn[0].disabled = true;
            }
            updateMemberHeaderCheckbox();
        });
        ctrl.staffFilterOptions = {
            filterText: '',
            // needed so we can ignore non-displayed data in the search
            useExternalFilter: true
        };
        ctrl.membersFilterOptions = {
            filterText: '',
            // needed so we can ignore non-displayed data in the search
            useExternalFilter: true
        };

        $scope.$watch('$ctrl.staffFilterOptions.filterText', function() {
            filterStaff();
        });
        $scope.$watch('$ctrl.membersFilterOptions.filterText', function() {
            filterMembers();
        });
        ctrl.staffColumnDefs = [
            { displayName: 'ID', field: 'code', width: '*' },
            { displayName: 'Staff', field: 'name', width: '**' },
            { displayName: '__isMember', field: '__isMember', visible: false }
        ];

        ctrl.membersColumnDefs = [
            { displayName: 'ID', field: 'code', width: '*' },
            { displayName: 'Staff', field: 'name', width: '**' },
            { displayName: '__isMember', field: '__isMember', visible: false }
        ];
        ctrl.staffToolbarBtn = [{
                id: 'bm-perm-grps-member-grid-toolbar-add',
                icon  : 'bento-icon-user-plus',
                action: function() {
                    ctrl.selectedStaff.forEach(function(item) {
                        item.__isMember = true;
                        ctrl.selectedMembers.push(item);
                    });

                    refreshTransferGrids();
                }
        }];
        ctrl.membersToolbarBtn = [{
            id: 'bm-perm-grps-member-grid-toolbar-cancel',
            icon  : 'bento-icon-user-cancel',
                action: function() {
                    ctrl.selectedMembers.forEach(function(item) {
                        item.__isMember = false;
                        ctrl.selectedStaff.push(item);
                    });

                    refreshTransferGrids();
                }
        }];
        function refreshTransferGrids() {
            ctrl.allStaffSelected = false;
            ctrl.allMembersSelected = false;
            ctrl.selectedStaff = [];
            ctrl.selectedMembers = [];
            clearSelections();
            filterStaff();
            filterMembers();
        }
        function clearSelections() {
            for (var i = 0, memberTtl = ctrl.memberGridCtrl.rows.length; i < memberTtl; i++) {
                ctrl.memberGridCtrl.rows[i].dataItem.selected = false;
            }
            for (var x = 0, staffTtl = ctrl.staffGridCtrl.rows.length; x < staffTtl; x++) {
                ctrl.staffGridCtrl.rows[x].dataItem.selected = false;
            }
        }
        function onStaffHeaderCheckboxChange() {
            ctrl.allStaffSelected = !ctrl.allStaffSelected;
            ctrl.selectedStaff = [];
            for (var i = 0, ttl = ctrl.staffGridCtrl.rows.length; i < ttl; i++) {
                ctrl.staffGridCtrl.rows[i].dataItem.selected = ctrl.allStaffSelected;
                if(ctrl.allStaffSelected) {
                    ctrl.selectedStaff.push(ctrl.staffGridCtrl.rows[i]._data);
                }
            }
        }
        function onMemberHeaderCheckboxChange() {
            ctrl.allMembersSelected = !ctrl.allMembersSelected;
            ctrl.selectedMembers = [];
            for (var i = 0, ttl = ctrl.memberGridCtrl.rows.length; i < ttl; i++) {
                ctrl.memberGridCtrl.rows[i].dataItem.selected = ctrl.allMembersSelected;
                if(ctrl.allMembersSelected){
                    ctrl.selectedMembers.push(ctrl.memberGridCtrl.rows[i]._data);
                }
            }
        }
        function onCheckboxChange(item, selectedItemArray) {
            if(item.selected) {
                selectedItemArray.push(item);
            } else {
                selectedItemArray.pop(item);
            }
        }
        function updateStaffHeaderCheckbox() {
            ctrl.allStaffSelected = false;
            var count = 0;
            if(ctrl.staffGridCtrl && ctrl.staffGridCtrl.rows.length > 0){
                for (var i = 0, ttl = ctrl.staffGridCtrl.rows.length; i < ttl; i++) {
                    if (ctrl.staffGridCtrl.rows[i].dataItem.selected === true) {
                        count++;
                    }
                }
                if (count === ctrl.staffGridCtrl.rows.length) {
                    ctrl.allStaffSelected = true;
                }
            }
        }

        function updateMemberHeaderCheckbox() {
            ctrl.allMembersSelected = false;
            var count = 0;
            if (ctrl.memberGridCtrl && ctrl.memberGridCtrl.rows.length > 0){
                for (var i = 0, ttl = ctrl.memberGridCtrl.rows.length; i < ttl; i++) {
                    if (ctrl.memberGridCtrl.rows[i].dataItem.selected === true) {
                        count++;
                    }
                }
                if (count === ctrl.memberGridCtrl.rows.length) {
                    ctrl.allMembersSelected = true;
                }
            }
        }
        function containsString(target, value) {
            return target.toLowerCase().indexOf(value.toLowerCase()) >= 0;
        }
        function filterStaff() {
            var value = ctrl.staffFilterOptions.filterText;
            ctrl.filteredStaff = $filter('filter')(ctrl.staff, function(item) {
                return !item.__isMember && (containsString(item.name, value) || containsString(item.code, value));
            });
        }

        function filterMembers() {
            var value = ctrl.membersFilterOptions.filterText;
            ctrl.filteredMembers = $filter('filter')(ctrl.staff, function(item) {
                return item.__isMember && (containsString(item.name, value) || containsString(item.code, value));
            });
        }

        // translations for JS strings
        function translateJsStrings() {
            $translate('Bluemoon.Core.Setup.Groups.MembersIdLabel').then(function(str) {
                ctrl.staffColumnDefs[0].displayName = str;
                ctrl.membersColumnDefs[0].displayName = str;
            });
            $translate('Bluemoon.Core.Setup.Groups.MembersStaffLabel').then(function(str) {
                ctrl.staffColumnDefs[1].displayName = str;
                ctrl.membersColumnDefs[1].displayName = str;
            });
            $translate('Bluemoon.Core.Setup.Groups.SetMembers.Remove').then(function(str) {
                ctrl.membersToolbarBtn[0].label = str;
            });
            $translate('Bluemoon.Core.Setup.Groups.SetMembers.Add').then(function(str) {
                ctrl.staffToolbarBtn[0].label = str;
            });
        }
	}
})(window.angular);

/*
 * Permission Groups Staff Selection Modal
*/
(function(angular){
	'use strict';
	angular.module('bmPermissionGroupsMembers').controller('bmPermissionGroupsStaffModalCtrl', PermissionGroupsStaffModalCtrl);

	PermissionGroupsStaffModalCtrl.$inject = ['$scope', '$filter', '$translate', 'staff', '$uibModalInstance', '$q'];
	function PermissionGroupsStaffModalCtrl($scope, $filter, $translate, staff, $uibModalInstance, $q) {
		var ctrl = this;

        ctrl.$onInit = function() {
            ctrl.staff = staff;
            ctrl.staffFilterOptions = { filterText: '' };
            translateJsStrings().then(function(){
                ctrl.staffGridColumns = [
                    {
                        binding: 'name',
                        header: ctrl.staffNameColumn,
                        width: '*',
                        filterType: 'input',
                        filterText: undefined
                    },
                    {
                        binding: 'code',
                        header: ctrl.staffIdColumn,
                        width: '*',
                        filterType: 'input',
                        filterText: undefined
                    },
                    {
                        binding: 'department',
                        header: ctrl.staffDepartmentColumn,
                        width: '*',
                        filterType: 'input',
                        filterText: undefined
                    }
                ];
                filterStaff();
            });
        };

        ctrl.addMembers = addMembers;
        ctrl.toggleFilters = toggleFilters;
        ctrl.updateMembers = updateMembers;
        ctrl.cancel = cancel;
        ctrl.filtersHidden = true;
        ctrl.groupPanelHidden = true;
        ctrl.selectedStaff = [];

        $scope.$watch('ctrl.staffFilterOptions.filterText', function() {
            filterStaff();
        });
		/* jshint validthis:true */
		function filterStaff() {
            var value = ctrl.staffFilterOptions.filterText;
            ctrl.filteredStaff = $filter('filter')(ctrl.staff, function(item) {
                return !item.__isMember && (containsString(item.name, value) || containsString(item.code, value));
            });
        }
        function containsString(target, value) {
            return target.toLowerCase().indexOf(value.toLowerCase()) >= 0;
        }
        function updateMembers($event) {
            ctrl.selectedStaff = $event.selectedItems;
        }
        function addMembers() {
            $uibModalInstance.close(ctrl.selectedStaff.forEach(function(item){
                item.__isMember = true;
                item.selected = false;
            }));
        }
        function cancel() {
            // TODO: Unselect all on cancel
            $uibModalInstance.dismiss('cancel');
        }
        function toggleFilters(value) {
            ctrl.filtersHidden = value ? value : !ctrl.filtersHidden;
        }
		function translateJsStrings() {
            return $q.all([
                $translate('Bluemoon.Core.Setup.Groups.MemberGrid.Name'),
                $translate('Bluemoon.Core.Setup.Groups.MemberGrid.StaffId'),
                $translate('Bluemoon.Core.Setup.Groups.MemberGrid.Department'),
                $translate('Bluemoon.Practice.Common.Grid.GroupPanel.Placeholder')
            ]).then(function(values) {
                ctrl.staffNameColumn = values[0];
                ctrl.staffIdColumn = values[1];
                ctrl.staffDepartmentColumn = values[2];
                ctrl.groupsPlaceholder = values[3];
            });
        }
	}
})(window.angular);

angular.module('bm-permission-groups.component.templates', ['components/bm-permission-groups-members/export/permission-groups-members.html', 'components/permission-groups-data/export/permission-groups-data.html', 'components/permission-groups-detail/export/permission-groups-detail.html', 'components/permission-groups-dropdown/export/permission-groups-dropdown.html', 'components/permission-groups-equation/export/permission-groups-equation.html', 'components/permission-groups-list/export/history-modal.html', 'components/permission-groups-list/export/permission-groups.html', 'components/permission-groups-members/export/permission-groups-members-grid.html', 'components/permission-groups-members/export/permission-groups-members.html', 'components/permission-groups-members/export/permission-groups-staff-modal.html', 'components/permission-groups-members/export/remove-members-confirmation-modal.html', 'components/permission-groups-picker/export/bm-permission-groups-picker.html', 'components/permission-groups-picker/export/permission-groups-picker.html']);

angular.module("components/bm-permission-groups-members/export/permission-groups-members.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/bm-permission-groups-members/export/permission-groups-members.html",
    "<div id=\"member-transferbox\" class=\"clearfix\">\n" +
    "    <div>\n" +
    "        <h4 translate=\"Bluemoon.Core.Setup.Groups.SetMembers.AvailStaff\"></h4>\n" +
    "        <div data-qe-id=\"bm-perm-grps-member-grid-toolbar\" bento-toolbar toolbar-data=\"$ctrl.staffToolbarBtn\" class=\"navbar navbar-default bento-toolbar\" aria-controls=\"table1\">\n" +
    "            <form data-qe-id=\"bm-perm-grps-member-grid-toolbar-search\" class=\"navbar-form navbar-right search-filter\" role=\"search\">\n" +
    "                <div class=\"form-group filter-container\">\n" +
    "                    <label class=\"sr-only\" for=\"staffSearch\" translate=\"Bluemoon.Core.Setup.Groups.Search\"></label>\n" +
    "                    <input data-qe-id=\"bm-perm-grps-member-grid-toolbar-search-input\" bento-reset type=\"text\" id=\"staffSearch\" class=\"form-control\" placeholder=\"{{ 'Bluemoon.Core.Setup.Groups.Search' | translate}}\" ng-model=\"$ctrl.staffFilterOptions.filterText\">\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "        <div bento-busy-loader=\"!$ctrl.staffLoaded\" bento-busy-loader-size=\"small\">\n" +
    "            <wj-flex-grid \n" +
    "            data-qe-id=\"bm-perm-grps-member-grid\"\n" +
    "            control=\"$ctrl.staffGridCtrl\" \n" +
    "            is-read-only=\"true\"\n" +
    "            class=\"bento-flex-grid\"\n" +
    "            items-source=\"$ctrl.filteredStaff\">\n" +
    "                <wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "                    <div ng-if=\"$col.index === 0\">\n" +
    "                        <i \n" +
    "                        data-qe-id=\"bm-perm-grps-member-grid-select-all-checkbox\"\n" +
    "                        ng-click=\"$ctrl.onStaffHeaderCheckboxChange($item)\"\n" +
    "                        class=\"bento-flex-grid-checkbox\"\n" +
    "                        ng-class=\"{'bento-icon-checkmark':$ctrl.allStaffSelected}\">\n" +
    "                        </i>\n" +
    "                    </div>\n" +
    "                </wj-flex-grid-cell-template>\n" +
    "                <wj-flex-grid-cell-template\n" +
    "                cell-type=\"RowHeader\">\n" +
    "                    <div ng-if=\"$col.index === 0\">\n" +
    "                        <i \n" +
    "                        data-qe-id=\"bm-perm-grps-member-grid-select-checkbox\"\n" +
    "                        ng-click=\"$item.selected = !$item.selected;$ctrl.onCheckboxChange($item, $ctrl.selectedStaff);\" \n" +
    "                        ng-model=\"$item.selected\" \n" +
    "                        class=\"bento-flex-grid-checkbox\"\n" +
    "                        ng-class=\"{'bento-icon-checkmark':$item.selected}\">\n" +
    "                        </i>\n" +
    "                    </div>\n" +
    "                </wj-flex-grid-cell-template>\n" +
    "                <wj-flex-grid-column data-qe-id=\"bm-perm-grps-member-grid-header-code\" header={{$ctrl.staffColumnDefs[0].displayName}} width=\"**\" binding=\"code\"></wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column data-qe-id=\"bm-perm-grps-member-grid-header-name\" header={{$ctrl.staffColumnDefs[1].displayName}} width=\"*\" binding=\"name\"></wj-flex-grid-column>\n" +
    "            </wj-flex-grid>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "        <h4 translate=\"Bluemoon.Core.Setup.Groups.SetMembers.SelectedStaff\"></h4>\n" +
    "        <div data-qe-id=\"bm-perm-grps-add-member-grid-toolbar\" bento-toolbar toolbar-data=\"$ctrl.membersToolbarBtn\" class=\"navbar navbar-default bento-toolbar\" aria-controls=\"table2\">\n" +
    "            <form class=\"navbar-form navbar-right search-filter\" role=\"search\">\n" +
    "                <div class=\"form-group filter-container\">\n" +
    "                    <label class=\"sr-only\" for=\"membersSearch\" translate=\"Bluemoon.Core.Setup.Groups.Search\"></label>\n" +
    "                    <input data-qe-id=\"bm-perm-grps-add-member-grid-toolbar-search\" bento-reset type=\"text\" id=\"membersSearch\" class=\"form-control\" placeholder=\"{{ 'Bluemoon.Core.Setup.Groups.Search' | translate}}\" ng-model=\"$ctrl.membersFilterOptions.filterText\">\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "        <div bento-busy-loader=\"!$ctrl.staffLoaded\" bento-busy-loader-size=\"small\">\n" +
    "            <wj-flex-grid \n" +
    "            control=\"$ctrl.memberGridCtrl\"\n" +
    "            data-qe-id=\"bm-perm-grps-add-member-grid\"\n" +
    "            is-read-only=\"true\"\n" +
    "            class=\"bento-flex-grid\"\n" +
    "            items-source=\"$ctrl.filteredMembers\">\n" +
    "                <wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "                    <div ng-if=\"$col.index === 0\">\n" +
    "                        <i\n" +
    "                        data-qe-id=\"bm-perm-grps-add-member-grid-select-all-checkbox\"\n" +
    "                        ng-click=\"$ctrl.onMemberHeaderCheckboxChange($item)\"\n" +
    "                        class=\"bento-flex-grid-checkbox\"\n" +
    "                        ng-class=\"{'bento-icon-checkmark':$ctrl.allMembersSelected}\">\n" +
    "                        </i>\n" +
    "                    </div>\n" +
    "                </wj-flex-grid-cell-template>\n" +
    "                <wj-flex-grid-cell-template\n" +
    "                cell-type=\"RowHeader\">\n" +
    "                    <div ng-if=\"$col.index === 0\">\n" +
    "                        <i \n" +
    "                        data-qe-id=\"bm-perm-grps-add-member-grid-select-checkbox\"\n" +
    "                        ng-click=\"$item.selected = !$item.selected;$ctrl.onCheckboxChange($item, $ctrl.selectedMembers);\" \n" +
    "                        ng-model=\"$item.selected\" \n" +
    "                        class=\"bento-flex-grid-checkbox\"\n" +
    "                        ng-class=\"{'bento-icon-checkmark':$item.selected}\">\n" +
    "                        </i>\n" +
    "                    </div>\n" +
    "                </wj-flex-grid-cell-template>\n" +
    "                <wj-flex-grid-column data-qe-id=\"bm-perm-grps-add-member-grid-header-code\" header={{$ctrl.staffColumnDefs[0].displayName}} width=\"**\" binding=\"code\"></wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column data-qe-id=\"bm-perm-grps-add-member-grid-header-name\" header={{$ctrl.staffColumnDefs[1].displayName}} width=\"*\" binding=\"name\"></wj-flex-grid-column>\n" +
    "            </wj-flex-grid>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("components/permission-groups-data/export/permission-groups-data.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-data/export/permission-groups-data.html",
    "<div id=\"perm-groups-data\">\n" +
    "    <div ng-if=\"!vm.hideContactFilters\">\n" +
    "        <div ng-if=\"!vm.readOnly\">\n" +
    "            <p translate=\"Bluemoon.Core.Setup.Groups.ClientData.Help\"></p>\n" +
    "        </div>\n" +
    "        <!-- Bento-Alert -->\n" +
    "        <bento-alert bento-alert-object=\"vm.permGrpClientDataFormAlerts\"></bento-alert>\n" +
    "        <div ng-if=\"!vm.readOnly\">\n" +
    "            <h3 translate=\"Bluemoon.Core.Setup.Groups.ClientData.ContactHeader\"></h3>\n" +
    "            <p translate=\"Bluemoon.Core.Setup.Groups.ClientData.ContactDesc\"></p>\n" +
    "        </div>\n" +
    "        <div bento-busy-loader=\"vm.loadingClients\">\n" +
    "            <form name=\"vm.permGrpClientDataForm\" role=\"form\">\n" +
    "                <div class=\"btn-group toggle-group\">\n" +
    "                    <button ng-disabled=\"vm.readOnly\" data-qe-id=\"selected-contacts-toggle-false\" ng-change=\"vm.selectedContactsToggleChange()\" type=\"button\" class=\"btn btn-default btn-toggle left-toggle\" ng-model=\"vm.selectedContacts\" uib-btn-radio=\"false\" translate=\"Bluemoon.Core.Setup.Groups.ClientData.NoClients\"></button>\n" +
    "                    <button ng-disabled=\"vm.readOnly\" data-qe-id=\"selected-contacts-toggle-true\" ng-change=\"vm.selectedContactsToggleChange()\" type=\"button\" class=\"btn btn-default btn-toggle right-toggle\" ng-model=\"vm.selectedContacts\" uib-btn-radio=\"true\" translate=\"Bluemoon.Core.Setup.Groups.ClientData.SelectedClients\"></button>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.selectedContacts\">\n" +
    "                    <div class=\"form-group\" data-ng-class=\"{ 'has-error' : !vm.nonConfContactsSelected && !vm.confContactsSelected }\">\n" +
    "                        <div class=\"conf-checkbox\" aria-labelledby=\"non-confidential\">\n" +
    "                            <input\n" +
    "                                id=\"check-non-confidential\"\n" +
    "                                data-qe-id=\"nonconf-checkbox\"\n" +
    "                                type=\"checkbox\"\n" +
    "                                name=\"permGrpClientSelectNonConf\"\n" +
    "                                ng-model=\"vm.nonConfContactsSelected\"\n" +
    "                                ng-change=\"vm.updateNonConfContactFilter()\"\n" +
    "                                ng-disabled=\"vm.readOnly\">&nbsp;\n" +
    "                            <label id=\"non-confidential\" for=\"check-non-confidential\" translate=\"Bluemoon.Core.Setup.Groups.ClientData.NonConfidentialClients\"></label>\n" +
    "                        </div>\n" +
    "                        <div class=\"conf-checkbox\" aria-labelledby=\"confidential\">\n" +
    "                            <input\n" +
    "                                id=\"check-confidential\"\n" +
    "                                data-qe-id=\"selected-cont-checkbox\"\n" +
    "                                type=\"checkbox\"\n" +
    "                                name=\"permGrpClientSelectConf\"\n" +
    "                                ng-model=\"vm.confContactsSelected\"\n" +
    "                                ng-change=\"vm.updateConfContactFilter()\"\n" +
    "                                ng-disabled=\"vm.readOnly\">&nbsp;\n" +
    "                            <label id=\"confidential\" for=\"check-confidential\" translate=\"Bluemoon.Core.Setup.Groups.ClientData.ConfidentialClients\"></label>\n" +
    "                        </div>\n" +
    "                        <div class=\"msg\" translate=\"Bluemoon.Core.Setup.Groups.ClientSelectHelp\"></div>\n" +
    "                    </div>\n" +
    "                    <div class=\"selected-radio-btn-group\" data-qe-id=\"selected-conf-radio-btn\" ng-if=\"vm.confContactsSelected\">\n" +
    "                        <div>\n" +
    "                            <input data-qe-id=\"selected-conf-radio-btn-all-contacts\" ng-disabled=\"vm.readOnly\" type=\"radio\" ng-change=\"vm.allConfSelectionChanged()\" ng-model=\"vm.selectedConfContacts\" ng-value=\"false\">&nbsp;<span translate=\"Bluemoon.Core.Setup.Groups.ClientData.AllConfidential\"></span>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.clientList.length > 0\" class=\"client-select\">\n" +
    "                            <div>\n" +
    "                                <input data-qe-id=\"selected-conf-radio-btn-selected-contacts\" ng-disabled=\"vm.readOnly\" type=\"radio\" ng-change=\"vm.allConfSelectionChanged()\" ng-model=\"vm.selectedConfContacts\" ng-value=\"true\">&nbsp;<span translate=\"Bluemoon.Core.Setup.Groups.ClientData.Selected\"></span>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            data-qe-id=\"contact-multiselect\"\n" +
    "                            ng-disabled=\"vm.readOnly\"\n" +
    "                            class=\"client-multiselect\"\n" +
    "                            bento-multiselect-overlay\n" +
    "                            ng-model=\"vm.selectedContactsList\"\n" +
    "                            ng-change=\"vm.selectedContactsChanged()\"\n" +
    "                            list-data=\"vm.clientList\"\n" +
    "                            revert-selections-on-dismissal=\"true\"\n" +
    "                            selected-info-text=\"{{'NUMBER ' + vm.selectedText}}\"\n" +
    "                            ng-if=\"vm.selectedConfContacts && vm.clientList.length > 0\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div bm-if-perm=\"Platform.GranularPermissionsClientFilters\">\n" +
    "                        <div ng-if=\"!vm.readOnly\">\n" +
    "                            <div ng-if=\"!vm.readOnly\">\n" +
    "                                <h3 translate=\"Bluemoon.Core.Setup.Groups.ClientData.Clients\"></h3>\n" +
    "                                <p translate=\"Bluemoon.Core.Setup.Groups.ClientData.ClientsFilterDesc\"></p>\n" +
    "                            </div>\n" +
    "                            <bm-permission-groups-dropdown type=\"client_office\"></bm-permission-groups-dropdown>\n" +
    "                            <bm-permission-groups-dropdown type=\"client_partner\"></bm-permission-groups-dropdown>\n" +
    "                            <bm-permission-groups-dropdown type=\"client_manager\"></bm-permission-groups-dropdown>\n" +
    "                            <bm-permission-groups-dropdown type=\"client_associate\"></bm-permission-groups-dropdown>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div bm-if-perm=\"Platform.GranularPermissionsStaffFilters\">\n" +
    "                        <div ng-if=\"!vm.readOnly\">\n" +
    "                            <div ng-if=\"!vm.readOnly\">\n" +
    "                                <h3 translate=\"Bluemoon.Core.Setup.Groups.Data.Staff\"></h3>\n" +
    "                                <p translate=\"Bluemoon.Core.Setup.Groups.StaffData.AccessDesc\"></p>\n" +
    "                                <div class=\"btn-group toggle-group\">\n" +
    "                                    <button\n" +
    "                                        data-qe-id=\"staff-filter-toggle-allstaff\"\n" +
    "                                        ng-disabled=\"vm.readOnly\"\n" +
    "                                        ng-change=\"vm.selectedStaffToggleChange()\"\n" +
    "                                        type=\"button\"\n" +
    "                                        class=\"btn btn-default btn-toggle right-toggle\"\n" +
    "                                        ng-model=\"vm.groupData.selectedStaff\"\n" +
    "                                        uib-btn-radio=\"'allStaff'\"\n" +
    "                                        translate=\"Bluemoon.Core.Setup.Groups.StaffData.AllStaff\">\n" +
    "                                    </button>\n" +
    "                                    <button\n" +
    "                                        data-qe-id=\"staff-filter-toggle-customstaff\"\n" +
    "                                        ng-disabled=\"vm.readOnly\"\n" +
    "                                        ng-change=\"vm.selectedStaffToggleChange()\"\n" +
    "                                        type=\"button\"\n" +
    "                                        class=\"btn btn-default btn-toggle right-toggle\"\n" +
    "                                        ng-model=\"vm.groupData.selectedStaff\"\n" +
    "                                        uib-btn-radio=\"'customStaff'\"\n" +
    "                                        translate=\"Bluemoon.Core.Setup.Groups.Customized\">\n" +
    "                                    </button>\n" +
    "                                    <button\n" +
    "                                        ng-disabled=\"vm.readOnly\"\n" +
    "                                        ng-change=\"vm.selectedStaffToggleChange()\"\n" +
    "                                        type=\"button\"\n" +
    "                                        data-qe-id=\"staff-filter-toggle-noStaff\"\n" +
    "                                        class=\"btn btn-default btn-toggle left-toggle\"\n" +
    "                                        ng-model=\"vm.groupData.selectedStaff\"\n" +
    "                                        uib-btn-radio=\"'noStaff'\"\n" +
    "                                        translate=\"Bluemoon.Core.Setup.Groups.StaffData.NoStaff\">\n" +
    "                                    </button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div ng-if=\"vm.groupData.selectedStaff==='customStaff'\">\n" +
    "                                <p translate=\"Bluemoon.Core.Setup.Groups.Data.StaffFilterDesc\"></p>\n" +
    "                                <bm-permission-groups-dropdown type=\"staff_office\"></bm-permission-groups-dropdown>\n" +
    "                                <bm-permission-groups-dropdown type=\"staff_department\"></bm-permission-groups-dropdown>\n" +
    "                                <bm-permission-groups-dropdown type=\"staff_supervisor\"></bm-permission-groups-dropdown>\n" +
    "                                <bm-permission-groups-dropdown type=\"staff_level\"></bm-permission-groups-dropdown>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div bm-if-has-access=\"DMS_FolderTemplateGroupPermissions\">\n" +
    "        <div ng-if=\"vm.templateFolderPermission\">\n" +
    "            <h3 translate=\"bm.permissiongroups.TemplateFolders.Header\"></h3>\n" +
    "            <p translate=\"bm.permissiongroups.TemplateFolders.Desc\"></p>\n" +
    "            <div class=\"btn-group toggle-group\">\n" +
    "                <button\n" +
    "                ng-disabled=\"vm.readOnly\"\n" +
    "                data-qe-id=\"bm-perm-grps-template-folders-toggle-false\"\n" +
    "                ng-change=\"vm.selectedTemplatesToggleChange()\"\n" +
    "                type=\"button\"\n" +
    "                class=\"btn btn-default btn-toggle left-toggle\"\n" +
    "                ng-model=\"vm.selectedTemplates\"\n" +
    "                uib-btn-radio=\"false\"\n" +
    "                translate=\"bm.permissiongroups.TemplateFolders.NoTemplates\">\n" +
    "                </button>\n" +
    "                <button\n" +
    "                ng-disabled=\"vm.readOnly\"\n" +
    "                data-qe-id=\"bm-perm-grps-template-folders-toggle-true\"\n" +
    "                ng-change=\"vm.selectedTemplatesToggleChange()\"\n" +
    "                type=\"button\"\n" +
    "                class=\"btn btn-default btn-toggle right-toggle\"\n" +
    "                ng-model=\"vm.selectedTemplates\"\n" +
    "                uib-btn-radio=\"true\"\n" +
    "                translate=\"bm.permissiongroups.TemplateFolders.SelectedTemplates\">\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.selectedTemplates\" class=\"selected-radio-btn-group\" data-qe-id=\"selected-templates-radio-btn-grp\" >\n" +
    "                <div>\n" +
    "                    <input data-qe-id=\"selected-templates-radio-btn-all\" ng-disabled=\"vm.readOnly\" type=\"radio\" ng-change=\"vm.allTemplatesSelectionChanged()\" ng-model=\"vm.allTemplates\" ng-value=\"true\">&nbsp;<span translate=\"bm.permissiongroups.TemplateFolders.AllTemplates\"></span>\n" +
    "                </div>\n" +
    "                <div class=\"client-select\">\n" +
    "                    <div>\n" +
    "                        <input ng-disabled=\"vm.readOnly\" type=\"radio\" ng-change=\"vm.allTemplatesSelectionChanged()\" ng-model=\"vm.allTemplates\" ng-value=\"false\" data-qe-id=\"selected-templates-radio-btn-selected\">&nbsp;<span translate=\"bm.permissiongroups.TemplateFolders.SelectedSharedTemplates\"></span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    data-qe-id=\"bm-perm-grps-folder-templates-multiselect\"\n" +
    "                    ng-disabled=\"vm.readOnly\"\n" +
    "                    class=\"client-multiselect\"\n" +
    "                    bento-multiselect-overlay\n" +
    "                    ng-model=\"vm.selectedTemplatesList\"\n" +
    "                    ng-change=\"vm.selectedTemplatesChanged()\"\n" +
    "                    list-data=\"vm.folderTemplatesList\"\n" +
    "                    revert-selections-on-dismissal=\"true\"\n" +
    "                    selected-info-text=\"{{'NUMBER ' + vm.selectedText}}\"\n" +
    "                    ng-if=\"vm.allTemplates === false\">\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/permission-groups-detail/export/permission-groups-detail.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-detail/export/permission-groups-detail.html",
    "<div id=\"permission-groups-detail\" class=\"permission-groups-view\" bento-busy-loader=\"(vm.editMode && !vm.group.type) || vm.isSaving\">\n" +
    "    <!-- Bento-Alert -->\n" +
    "    <bento-alert bento-alert-object=\"vm.permGrpNameFormAlerts\"></bento-alert>\n" +
    "    <h1>\n" +
    "        <span ng-if=\"vm.editMode\" translate=\"Bluemoon.Core.Setup.Groups.EditModeTitle\"></span>\n" +
    "        <span ng-if=\"!vm.editMode\" translate=\"Bluemoon.Core.Setup.Groups.AddModeTitle\"></span>\n" +
    "        <span ng-if=\"vm.group.name\"> - {{ vm.group.name }}</span>\n" +
    "        <span class=\"label label-info\" ng-if=\"vm.permissionGroup.data.system\" translate=\"Bluemoon.Core.Setup.Groups.Flag.SystemGroup\"></span>\n" +
    "    </h1>\n" +
    "\n" +
    "    <div bento-wizard\n" +
    "        on-change=\"vm.onWizardChange(step)\"\n" +
    "        on-finish=\"vm.wizardDone()\"\n" +
    "        use-side-arrows=\"true\"\n" +
    "        current-step=\"step\"\n" +
    "        hide-done-button=\"vm.loadingGroupData || vm.granPermsDisabled\">\n" +
    "        <ol class=\"steps\">\n" +
    "            <li data-qe-id=\"bmstaff-permgrpsdetail-name-step\">\n" +
    "                <span class=\"title\" translate=\"Bluemoon.Core.Setup.Groups.SetNameDesc.Title\"></span>\n" +
    "                <span class=\"description\" translate=\"Bluemoon.Core.Setup.Groups.SetNameDesc.Desc\"></span>\n" +
    "            </li>\n" +
    "            <li ng-if=\"!vm.granularPermsAccess\" data-qe-id=\"bmstaff-permgrpsdetail-perm-step\">\n" +
    "                <span class=\"title\" translate=\"Bluemoon.Core.Setup.Groups.SetPerms.Title\"></span>\n" +
    "                <span class=\"description\" translate=\"Bluemoon.Core.Setup.Groups.SetPerms.Desc\"></span>\n" +
    "            </li>\n" +
    "            <li ng-if=\"vm.granularPermsAccess\" data-qe-id=\"bmstaff-permgrpsdetail-perm-step\">\n" +
    "                <span class=\"title\" translate=\"Bluemoon.Core.Setup.Groups.SetFunctionality.Title\"></span>\n" +
    "                <span class=\"description\" translate=\"Bluemoon.Core.Setup.Groups.SetFunctionality.Desc\"></span>\n" +
    "            </li>\n" +
    "            <li ng-if=\"vm.granularPermsAccess\" data-qe-id=\"bmstaff-permgrpsdetail-client-step\">\n" +
    "                <span class=\"title\" translate=\"Bluemoon.Core.Setup.Groups.ClientData.Title\"></span>\n" +
    "                <span class=\"description\" translate=\"Bluemoon.Core.Setup.Groups.ClientData.Desc\"></span>\n" +
    "            </li>\n" +
    "            <li ng-disabled=\"vm.membersStepDisabled\" data-qe-id=\"bmstaff-permgrpsdetail-member-step\">\n" +
    "                <span class=\"title\" translate=\"Bluemoon.Core.Setup.Groups.SetMembers.Title\"></span>\n" +
    "                <span class=\"description\" translate=\"Bluemoon.Core.Setup.Groups.SetMembers.Desc\"></span>\n" +
    "            </li>\n" +
    "        </ol>\n" +
    "        <ul class=\"contents\">\n" +
    "            <li bento-busy-loader=\"vm.loadingGroupData\">\n" +
    "                <div class=\"row\">\n" +
    "                    <form class=\"col-md-4\" name=\"vm.permGrpNameForm\" role=\"form\">\n" +
    "                        <div class=\"form-group\" data-ng-class=\"{ 'has-error' :\n" +
    "                        ((vm.permGrpNameForm.permGrpName.$error.required || vm.permGrpNameForm.permGrpName.$error.bmUniquePermissionGroupName) && vm.permGrpNameForm.permGrpName.$dirty) }\">\n" +
    "\n" +
    "                            <label for=\"permgrpName\"><span translate=\"Bluemoon.Core.Setup.Groups.NameLabel\"></span>*</label>\n" +
    "                            <input ng-disabled=\"vm.permissionGroup.data.system\" id=\"permgrpName\" name=\"permGrpName\" class=\"form-control\" type=\"text\" aria-describedby=\"permgrpNameErrorsContainer\" data-qe-id=\"bmstaff-permgrpsdetail-name-input\" ng-model=\"vm.group.name\" autocomplete=\"off\" bm-focus=\"true\" required bm-unique-permission-group-name ng-model-options=\"{ debounce: 500 }\">\n" +
    "\n" +
    "                            <ng-messages id=\"permgrpNameErrorsContainer\" class=\"msg\" for=\"vm.permGrpNameForm.permGrpName.$error\">\n" +
    "                                <ng-message when=\"required\"><span translate=\"Bluemoon.Core.Setup.Groups.NameHelp\"></span></ng-message>\n" +
    "                                <ng-message when=\"bmUniquePermissionGroupName\"><span translate=\"Bluemoon.Core.Setup.Groups.NonUniqueNameMsg\"></span></ng-message>\n" +
    "                            </ng-messages>\n" +
    "                            <div class=\"pending-msg\" ng-show=\"vm.permGrpNameForm.permGrpName.$pending\" translate=\"Bluemoon.Core.Setup.Groups.NonUniqueNamePendingMsg\"></div>\n" +
    "                            <div class=\"valid-msg\" ng-show=\"vm.group.name !== vm.group.__origName && vm.permGrpNameForm.permGrpName.$valid\" translate=\"Bluemoon.Core.Setup.Groups.ValidNameMsg\"></div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div class=\"form-group\" data-ng-class=\"{ 'has-error' :\n" +
    "                        (vm.permGrpNameForm.permGrpDesc.$error.required && vm.permGrpNameForm.permGrpDesc.$dirty) }\">\n" +
    "\n" +
    "                            <label for=\"permGrpDesc\"><span translate=\"Bluemoon.Core.Setup.Groups.DescLabel\"></span>*</label>\n" +
    "                            <input ng-disabled=\"vm.permissionGroup.data.system\" id=\"permGrpDesc\" name=\"permGrpDesc\" class=\"form-control\" type=\"text\" aria-describedby=\"permGrpDescErrorContainer\" data-qe-id=\"bmstaff-permgrpsdetail-desc-input\" ng-model=\"vm.group.description\" autocomplete=\"off\" required>\n" +
    "\n" +
    "                            <ng-messages id=\"permGrpDescErrorContainer\" class=\"msg\" for=\"vm.permGrpNameForm.permGrpDesc.$error\">\n" +
    "                                <ng-message when=\"required\"><span translate=\"Bluemoon.Core.Setup.Groups.DescHelp\"></span></ng-message>\n" +
    "                            </ng-messages>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div translate=\"Bluemoon.Core.Setup.Common.RequiredField\"></div>\n" +
    "                    </form>\n" +
    "                </div>\n" +
    "                <div bm-if-perm=\"Platform.GranularPermissions\" class=\"row\">\n" +
    "                    <div class=\"equation-container\">\n" +
    "                        <bm-permission-groups-equation></bm-permission-groups-equation>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li id=\"nucleus-form-wrapper\">\n" +
    "                <p translate=\"Bluemoon.Core.Setup.Groups.SetPerms.Help\"></p>\n" +
    "\n" +
    "                <nucleus-permissions-form read-only=\"vm.permissionGroup.data.system\" schema=\"vm.perms\"></nucleus-permissions-form>\n" +
    "            </li>\n" +
    "            <li ng-if=\"vm.granularPermsAccess\" bento-busy-loader=\"vm.loadingGroupData\">\n" +
    "                <bm-permission-groups-data ng-if=\"vm.permissionGroup\" read-only=\"vm.permissionGroup.data.system\" group-data=\"vm.permissionGroup\" on-filters-change=\"vm.updateGrpFilters($event)\">\n" +
    "                </bm-permission-groups-data>\n" +
    "            </li>\n" +
    "            <li bento-busy-loader=\"vm.loadingGroupData\">\n" +
    "                <div bm-if-perm=\"Platform.GranularPermissions\">\n" +
    "                    <p translate=\"Bluemoon.Core.Setup.Groups.SetMembers.Help\"></p>\n" +
    "                    <bm-permission-groups-members staff=\"vm.staff\" group-type=\"vm.permissionGroup.data.permissionGroupType\" group-name=\"vm.group.name\" on-members-change=\"vm.updateGrpMembers($event)\"></bm-permission-groups-members>\n" +
    "                </div>\n" +
    "                <div bm-if-not-perm=\"Platform.GranularPermissions\">\n" +
    "                    <permission-groups-members staff=\"vm.staff\" group-name=\"vm.group.name\" on-members-change=\"vm.updateGrpMembers($event)\"></permission-groups-members>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "        <!-- custom buttons -->\n" +
    "        <button class=\"btn btn-default pull-right\" data-qe-id=\"bmstaff-permgrpsdetail-cancel-btn\" ng-click=\"vm.wizardCancel()\" translate=\"Bluemoon.Core.Setup.Groups.Cancel\"></button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/permission-groups-dropdown/export/permission-groups-dropdown.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-dropdown/export/permission-groups-dropdown.html",
    "<div id=\"perm-groups-dropdown\">\n" +
    "    <div class=\"filter-select\">\n" +
    "        <input\n" +
    "            type=\"checkbox\"\n" +
    "            data-qe-id=\"office-match-checkbox\"\n" +
    "            name=\"permGrpClientOfficeMatches\"\n" +
    "            ng-model=\"$ctrl.selected\"\n" +
    "            ng-disabled=\"$ctrl.readOnly\"\n" +
    "            ng-change=\"$ctrl.selectedFilter = ''\">&nbsp;\n" +
    "        <span ng-bind-html=\"$ctrl.dropdownData.dropdownLabel\"></span>\n" +
    "        <div\n" +
    "            ng-if=\"$ctrl.dropdownData\"\n" +
    "            class=\"filter-dropdown\"\n" +
    "            bento-combobox\n" +
    "            on-change=\"vm.setSelectedFilter(item)\"\n" +
    "            label-name=\"displayName\"\n" +
    "            use-server=\"true\"\n" +
    "            data-qe-id=\"office-match-dropdown\"\n" +
    "            ng-model=\"$ctrl.selectedFilter\"\n" +
    "            get-data=\"$ctrl.getItems()\"\n" +
    "            ng-disabled=\"vm.readOnly || !$ctrl.selected\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("components/permission-groups-equation/export/permission-groups-equation.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-equation/export/permission-groups-equation.html",
    "<div ng-if=\"vm.isVisible\" id=\"permission-groups-equation\">\n" +
    "    <div class=\"explanation-container\">\n" +
    "        <div class=\"explanation\">\n" +
    "            <p translate=\"Bluemoon.Core.Setup.Groups.Explanation.Heading\"></p>\n" +
    "            <!-- Bluemoon.Core.Setup.Groups.Explanation.Desc and other translations have different\n" +
    "                 meanings in pt-BR since they have different requirements of permission groups -->\n" +
    "            <p translate=\"Bluemoon.Core.Setup.Groups.Explanation.Desc\"></p>\n" +
    "            <span><a data-qe-id=\"bm-perm-grps-equation-learn-more\" target=\"_blank\" ng-href=\"{{vm.bestPracticesUrl}}\"\n" +
    "                    translate=\"Bluemoon.Core.Setup.Groups.LearnMore\"></a></span>\n" +
    "            <span translate=\"Bluemoon.Core.Setup.And\"></span>\n" +
    "            <span><a data-qe-id=\"bm-perm-grps-equation-interact-help\" target=\"_blank\"\n" +
    "                    ng-href=\"{{vm.helpInteractionsUrl}}\" translate=\"Bluemoon.Core.Setup.Groups.InteractHelp\"></a></span>\n" +
    "        </div>\n" +
    "        <div class=\"explanation-operand\">\n" +
    "            <p translate=\"Bluemoon.Core.Setup.Groups.Explanation.Functionality.Heading\"></p>\n" +
    "            <div class=\"operand-box\">\n" +
    "                <div translate=\"Bluemoon.Core.Setup.Groups.Explanation.Functionality.Example\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"explanation-operator\">+</div>\n" +
    "        <div class=\"explanation-operand\">\n" +
    "            <p translate=\"Bluemoon.Core.Setup.Groups.Explanation.Data.Heading\"></p>\n" +
    "            <div class=\"operand-box\">\n" +
    "                <div translate=\"Bluemoon.Core.Setup.Groups.Explanation.Clients.Example\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"explanation-operator\">=</div>\n" +
    "        <div class=\"explanation-operand\">\n" +
    "            <p translate=\"Bluemoon.Core.Setup.Groups.Explanation.Total.Heading\"></p>\n" +
    "            <div class=\"operand-box\">\n" +
    "                <div translate=\"Bluemoon.Core.Setup.Groups.Explanation.Total.Example\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "        <button data-qe-id=\"bm-perm-grps-equation-toggle\" type=\"button\" class=\"close\" aria-hidden=\"true\"\n" +
    "            ng-click=\"vm.toggleVisibility()\">\n" +
    "            <i class=\"bento-icon-close-x\"></i>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("components/permission-groups-list/export/history-modal.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-list/export/history-modal.html",
    "<div id=\"perm-group-history-modal\">\n" +
    "	<button data-qe-id=\"bm-perm-grps-history-close-btn\" type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"ctrl.close()\">\n" +
    "		<i class=\"bento-icon-close-x\"></i>\n" +
    "	</button>\n" +
    "	<div class=\"modal-header\" translate=\"Reports.OnvioUsage.PermGroupHistory\"></div>\n" +
    "	<div class=\"modal-body\" bento-busy-loader=\"ctrl.isLoading\" bento-busy-loader-size=\"small\">\n" +
    "		<wj-flex-grid data-qe-id=\"bm-perm-grps-history-grid\" ng-show=\"ctrl.itemsLoaded\"\n" +
    "			auto-generate-columns=\"false\"\n" +
    "			class=\"bento-flex-grid\"\n" +
    "			control=\"ctrl.flex\"\n" +
    "			items-source=\"ctrl.gridData\"\n" +
    "			is-read-only=\"true\"\n" +
    "			sort-row-index=\"0\"\n" +
    "			show-sort=\"true\"\n" +
    "			min-height=\"150\"\n" +
    "			style=\"overflow: hidden\">\n" +
    "			<wj-flex-grid-column\n" +
    "				ng-repeat=\"column in ctrl.staffGridColumns\" \n" +
    "				binding=\"{{column.binding}}\"\n" +
    "				header=\"{{column.header}}\"\n" +
    "				width=\"{{column.width}}\">\n" +
    "			</wj-flex-grid-column>\n" +
    "		</wj-flex-grid>\n" +
    "		<div ng-if=\"!ctrl.itemsLoaded && ctrl.isLoading===false\" translate=\"Bluemoon.Practice.Common.List.NoGridEntries\"></div>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button data-qe-id=\"bm-perm-grps-history-done-btn\" class=\"btn btn-default\" translate=\"Bluemoon.Core.Setup.Groups.Done\" ng-click=\"ctrl.close()\"></button>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("components/permission-groups-list/export/permission-groups.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-list/export/permission-groups.html",
    "<div id=\"permission-groups-list\" class=\"permission-groups-view\">\n" +
    "    <div class=\"permission-groups-header\">\n" +
    "        <h1 translate=\"Bluemoon.Core.Setup.Groups.Title\"></h1>\n" +
    "        <button bm-if-perm=\"Platform.GranularPermissions\" type=\"button\" class=\"close\" ng-click=\"vm.toggleEquationVisibility()\" aria-label=\"{{vm.infoAriaLabel}}\">\n" +
    "            <i class=\"bento-icon-info\" role=\"tooltip\"></i>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "    <div bm-if-perm=\"Platform.GranularPermissions\" class=\"row\">\n" +
    "        <div class=\"equation-container\">\n" +
    "            <bm-permission-groups-equation></bm-permission-groups-equation>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"info-text\" aria-label=\"{{vm.infoAriaLabel}}\" aria-describedby=\"description\">\n" +
    "        <i class=\"bento-icon-info\"></i>\n" +
    "        <span role=\"tooltip\" id=\"description\" translate=\"Bluemoon.Core.Setup.Groups.ChangesDelay\"></span>\n" +
    "    </div>\n" +
    "    <div data-qe-id=\"bm-perm-grps-list-grid-toolbar\" bento-toolbar class=\"navbar navbar-default bento-toolbar\" aria-controls=\"table1\" toolbar-data=\"vm.toolbarButtons\">\n" +
    "        <ul class=\"nav navbar-right\" role=\"group\">\n" +
    "            <!-- user story 2503042: Show Deleted Groups toggle is not working. Let's hide unitl phase 2. -->\n" +
    "                <li ng-if=\"vm.granPermsAuditAccess\">\n" +
    "                    <div bento-toggle ng-model=\"vm.showDeletedGroups\" on-change=\"vm.deleteToggleChange()\">\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "                <li ng-if=\"vm.granPermsAuditAccess\">\n" +
    "                    <div class=\"delete-toggle-label\">\n" +
    "                        <span translate=\"Bluemoon.Core.Setup.Groups.Toggle.ShowDeletedGroups\"></span>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "\n" +
    "            <li>\n" +
    "                <form class=\"navbar-form navbar-right search-filter\" role=\"search\">\n" +
    "                    <div class=\"form-group filter-container\">\n" +
    "                        <label class=\"sr-only\" for=\"secGrpSearch\" translate=\"Bluemoon.Core.Setup.Groups.Search\"></label>\n" +
    "                        <input data-qe-id=\"bm-perm-grps-list-grid-toolbar-search\" bento-reset type=\"text\" id=\"secGrpSearch\" class=\"form-control\" placeholder=\"{{ 'Bluemoon.Core.Setup.Groups.Search' | translate}}\" ng-model=\"vm.filterOptions.filterText\">\n" +
    "                    </div>\n" +
    "                </form>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "    <div bento-busy-loader=\"vm.loadingGroups\">\n" +
    "        <wj-flex-grid data-qe-id=\"bm-perm-grps-list-grid\" select-mode=\"0\" control=\"vm.flexGrid\" show-sort=\"true\" is-read-only=\"true\" class=\"bento-flex-grid\" items-source=\"vm.filteredGridData\" auto-row-heights=\"true\">\n" +
    "            <wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "                <div ng-if=\"$col.index === 0\">\n" +
    "                    <input type=\"checkbox\"\n" +
    "                    data-qe-id=\"bm-perm-grps-list-grid-select-all-checkbox\"\n" +
    "                    ng-click=\"vm.onHeaderCheckboxChange()\"\n" +
    "                    class=\"bento-flex-grid-checkbox\"\n" +
    "                    ng-class=\"{'bento-icon-checkmark':vm.allSelected}\">\n" +
    "                </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "            <wj-flex-grid-cell-template cell-type=\"RowHeader\">\n" +
    "                <div ng-if=\"$col.index === 0 && !vm.isSystemGroup($item.permissionGroupType)\">\n" +
    "                    <input type=\"checkbox\"\n" +
    "                        data-qe-id=\"bm-perm-grps-list-grid-select-checkbox\"\n" +
    "                        ng-if=\"!$item.deleted\"\n" +
    "                        ng-click=\"$item.selected = !$item.selected;vm.onCheckboxChange($item);\"\n" +
    "                        ng-model=\"$item.selected\"\n" +
    "                        class=\"bento-flex-grid-checkbox\"\n" +
    "                        ng-class=\"{'bento-icon-checkmark':$item.selected}\">\n" +
    "                </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "            <!-- user story 2503042: Actions column should be hidden - will not be available until phase 2. -->\n" +
    "            <!--\n" +
    "                <wj-flex-grid-column ng-if=\"vm.granPermsAuditAccess\" header={{vm.actionsHeader}} width=\"100\" binding=\"\">\n" +
    "                    <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                        <span data-qe-id=\"bm-perm-grps-list-grid-history\" class=\"bento-icon-info grid-action-icon\" ng-click=\"vm.getHistory($item)\"></span>\n" +
    "                    </wj-flex-grid-cell-template>\n" +
    "                </wj-flex-grid-column>\n" +
    "            -->\n" +
    "            <wj-flex-grid-column header={{vm.columnDefs[0].displayName}} width=\"3*\" binding=\"name\" word-wrap=\"true\">\n" +
    "                <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                    <div>\n" +
    "                        <a data-qe-id=\"bm-perm-grps-list-grid-grp\"\n" +
    "                            ng-if=\"!$item.deleted\"\n" +
    "                            ng-href=\"#/setup/permission-groups/{{ $item.subjectGroupId }}\"\n" +
    "                            tooltip-placement=\"top\"\n" +
    "                            tooltip-append-to-body=\"true\"\n" +
    "                            uib-tooltip=\"{{$item.name}}\"\n" +
    "                            class=\"word-break\">\n" +
    "                            {{$item.name}}\n" +
    "                        </a>\n" +
    "                        <a data-qe-id=\"bm-perm-grps-list-grid-grp\"\n" +
    "                            ng-if=\"$item.deleted\"\n" +
    "                            ng-class=\"{'delete-group':vm.deletedGroup && $item.deleted}\"\n" +
    "                            tooltip-placement=\"top\"\n" +
    "                            tooltip-append-to-body=\"true\"\n" +
    "                            uib-tooltip=\"{{$item.name}}\"\n" +
    "                            class=\"word-break\">\n" +
    "                            {{$item.name}}\n" +
    "                        </a>\n" +
    "                        <span class=\"badge primary\"\n" +
    "                            ng-if=\"$item.deleted && vm.granPermsAuditAccess\"\n" +
    "                            translate=\"Bluemoon.Core.Setup.Groups.LastEvent.Deleted\">\n" +
    "                        </span>\n" +
    "                        <span class=\"label label-info word-break white-space-breaks\"\n" +
    "                            ng-if=\"vm.isSystemGroup($item.permissionGroupType)\"\n" +
    "                            translate=\"Bluemoon.Core.Setup.Groups.Flag.SystemGroup\">\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                </wj-flex-grid-cell-template>\n" +
    "            </wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column header={{vm.columnDefs[1].displayName}} width=\"6*\" binding=\"description\" word-wrap=\"true\">\n" +
    "                <div ng-class=\"{'delete-group':vm.deletedGroup && $item.deleted}\"\n" +
    "                    tooltip-placement=\"top\"\n" +
    "                    tooltip-append-to-body=\"true\"\n" +
    "                    uib-tooltip=\"{{$item.description}}\">\n" +
    "                    {{$item.description}}\n" +
    "                </div>\n" +
    "            </wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column ng-if=\"vm.granPermsAuditAccess\" header={{vm.columnDefs[2].displayName}} width=\"*\" binding=\"lastevent\">\n" +
    "                <div ng-class=\"{'delete-group':vm.deletedGroup && $item.deleted}\">\n" +
    "                    {{$item.lastevent}}\n" +
    "                </div>\n" +
    "            </wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column ng-if=\"vm.granPermsAuditAccess\" header={{vm.columnDefs[3].displayName}} width=\"*\" binding=\"eventby\">\n" +
    "                <div ng-class=\"{'delete-group':vm.deletedGroup && $item.deleted}\">\n" +
    "                    {{$item.eventby}}\n" +
    "                </div>\n" +
    "            </wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column ng-if=\"vm.granPermsAuditAccess\" header={{vm.columnDefs[4].displayName}} width=\"2*\" binding=\"lasteventdate\">\n" +
    "                <div ng-class=\"{'delete-group':vm.deletedGroup && $item.deleted}\">\n" +
    "                    {{$item.lasteventdate}}\n" +
    "                </div>\n" +
    "            </wj-flex-grid-column>\n" +
    "        </wj-flex-grid>\n" +
    "    </div>\n" +
    "    <script type=\"text/ng-template\" id=\"permGroupDeleteConfirmation.html\">\n" +
    "        <div class=\"modal-body modal-confirm-body\">\n" +
    "            <i class=\"glyphicons warning_sign modal-confirm-icon\"></i>\n" +
    "            <span class=\"modal-confirm-message\" translate=\"Bluemoon.Core.Setup.Groups.ConfirmDelete\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button data-qe-id=\"bm-perm-grps-list-delete-modal-confirm\" class=\"btn btn-primary\" ng-click=\"conf.confirmDelete()\" translate=\"Bluemoon.Core.Setup.Groups.Delete\"></button>\n" +
    "            <button data-qe-id=\"bm-perm-grps-list-delete-modal-cancel\" class=\"btn btn-default\" ng-click=\"conf.cancelDelete()\" translate=\"Bluemoon.Core.Setup.Groups.Cancel\"></button>\n" +
    "        </div>\n" +
    "    </script>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/permission-groups-members/export/permission-groups-members-grid.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-members/export/permission-groups-members-grid.html",
    "<wj-group-panel\n" +
    "data-qe-id=\"bm-perm-grp-members-grid-panel\"\n" +
    "grid=\"$ctrl.gridCtrl\"\n" +
    "placeholder=\"{{$ctrl.groupsPlaceholder}}\"\n" +
    "hide-grouped-columns=\"false\"\n" +
    "ng-if=\"!$ctrl.groupPanelHidden\">\n" +
    "</wj-group-panel>\n" +
    "<wj-flex-grid\n" +
    "data-qe-id=\"bm-perm-grp-members-grid\"\n" +
    "control=\"$ctrl.gridCtrl\"\n" +
    "is-read-only=\"true\"\n" +
    "class=\"bento-flex-grid\"\n" +
    "items-source=\"$ctrl.gridCollectionView\"\n" +
    "sort-row-index=\"0\">\n" +
    "    <wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "        <div ng-if=\"$col.index === 1 && $row.index!=1\">\n" +
    "            <input type =\"checkbox\"\n" +
    "            data-qe-id=\"bm-perm-grp-members-grid-select-all-checkbox\"\n" +
    "            ng-click=\"$ctrl.onHeaderCheckboxChange($item)\"\n" +
    "            class=\"bento-flex-grid-checkbox\"\n" +
    "            ng-class=\"{'bento-icon-checkmark':$ctrl.allItemsSelected}\"\n" +
    "            aria-label=\"Select All\">\n" +
    "        </div>\n" +
    "    </wj-flex-grid-cell-template>\n" +
    "    <wj-flex-grid-cell-template\n" +
    "    cell-type=\"RowHeader\">\n" +
    "        <div ng-if=\"$col.index === 0\">{{$row.index+1}}</div>\n" +
    "        <div ng-if=\"$col.index===1 && !($ctrl.groupType === 'system.administrators' && $item.isUberAdmin)\">\n" +
    "            <input type=\"checkbox\"\n" +
    "            data-qe-id=\"bm-perm-grp-members-grid-select-checkbox\"\n" +
    "            ng-click=\"$item.selected = !$item.selected;$ctrl.onCheckboxChange($item);\"\n" +
    "            ng-model=\"$item.selected\"\n" +
    "            class=\"bento-flex-grid-checkbox\"\n" +
    "            ng-class=\"{'bento-icon-checkmark':$item.selected}\"\n" +
    "            aria-label=\"{{$item.name + $item.code + $item.department}}\">\n" +
    "        </div>\n" +
    "    </wj-flex-grid-cell-template>\n" +
    "    <wj-flex-grid-cell-template\n" +
    "    cell-type=\"GroupHeader\">\n" +
    "        <i class=\"collapse-icon\" ng-class=\"{'bento-icon-expand':$row.isCollapsed,'bento-icon-collapse':!$row.isCollapsed}\" ng-click=\"$row.isCollapsed = !$row.isCollapsed\"></i> {{$item.name}} ({{$item.items.length}})\n" +
    "    </wj-flex-grid-cell-template>\n" +
    "    <wj-flex-grid-column ng-repeat=\"col in $ctrl.columns\" header=\"{{col.header}}\" width=\"{{col.width}}\" binding=\"{{col.binding}}\">\n" +
    "        <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "            <div ng-if=\"$row.index===0\">{{$col.header}} <i ng-class=\"{'bento-icon-chevron-down':$col.currentSort==='-', 'bento-icon-chevron-up':$col.currentSort==='+'}\"></i></div>\n" +
    "            <div ng-if=\"$ctrl.filtersHidden&&$row.index===1\">{{$col.header}} <i ng-class=\"{'bento-icon-chevron-down':$col.currentSort==='-', 'bento-icon-chevron-up':$col.currentSort==='+'}\"></i></div>\n" +
    "            <div ng-if=\"!$ctrl.filtersHidden&&$row.index===1&&col.binding==='name'\">\n" +
    "                <input type=\"text\"\n" +
    "                class=\"form-control\"\n" +
    "                id=\"filter-{{$col.binding}}\"\n" +
    "                ng-focus=\"col.focused = $event\"\n" +
    "                ng-change=\"$ctrl.updateFilter($col.binding)\"\n" +
    "                ng-keydown=\"$event.stopPropagation()\"\n" +
    "                ng-keypress=\"$event.stopPropagation()\"\n" +
    "                ng-model=\"col.filterText\"\n" +
    "                tabindex=\"0\">\n" +
    "            </div>\n" +
    "            <div ng-if=\"!$ctrl.filtersHidden&&$row.index===1&&col.binding==='code'\">\n" +
    "                <input type=\"text\"\n" +
    "                class=\"form-control\"\n" +
    "                id=\"filter-{{$col.binding}}\"\n" +
    "                ng-focus=\"col.focused = $event\"\n" +
    "                ng-change=\"$ctrl.updateFilter($col.binding)\"\n" +
    "                ng-keydown=\"$event.stopPropagation()\"\n" +
    "                ng-keypress=\"$event.stopPropagation()\"\n" +
    "                ng-model=\"col.filterText\"\n" +
    "                tabindex=\"0\">\n" +
    "            </div>\n" +
    "            <div ng-if=\"!$ctrl.filtersHidden&&$row.index===1&&col.binding==='department'\">\n" +
    "                <input type=\"text\"\n" +
    "                class=\"form-control\"\n" +
    "                id=\"filter-{{$col.binding}}\"\n" +
    "                ng-focus=\"col.focused = $event\"\n" +
    "                ng-change=\"$ctrl.updateFilter($col.binding)\"\n" +
    "                ng-keydown=\"$event.stopPropagation()\"\n" +
    "                ng-keypress=\"$event.stopPropagation()\"\n" +
    "                ng-model=\"col.filterText\"\n" +
    "                tabindex=\"0\">\n" +
    "            </div>\n" +
    "        </wj-flex-grid-cell-template>\n" +
    "    </wj-flex-grid-column>\n" +
    "</wj-flex-grid>\n" +
    "");
}]);

angular.module("components/permission-groups-members/export/permission-groups-members.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-members/export/permission-groups-members.html",
    "<div id=\"member-transferbox\" class=\"clearfix\">\n" +
    "    <div>\n" +
    "        <div bento-toolbar toolbar-data=\"$ctrl.membersToolbarBtn\" class=\"navbar navbar-default bento-toolbar\" aria-controls=\"table2\">\n" +
    "            <ul class=\"nav navbar-right\" role=\"group\">\n" +
    "                <li>\n" +
    "                    <button\n" +
    "                        data-qe-id=\"bm-perm-grp-members-grid-toggle-filters-btn\"\n" +
    "                        tooltip-placement=\"top\"\n" +
    "                        tooltip-append-to-body=\"true\"                        \n" +
    "                        uib-tooltip=\"{{$ctrl.showFilters}}\"        \n" +
    "                        tooltip-trigger=\"'focus mouseenter'\"                \n" +
    "                        aria-label=\"{{$ctrl.showFilters}}\"\n" +
    "                        ng-click=\"$ctrl.toggleFilters()\"\n" +
    "                        class=\"navbar-right btn btn-default btn-icon btn-toggle\"\n" +
    "                        ng-class=\"{ active: !$ctrl.filtersHidden}\"\n" +
    "                        ng-disabled=\"!$ctrl.groupPanelHidden\">\n" +
    "                        <i class=\"bento-icon-filter-az\"></i>\n" +
    "                    </button>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <button\n" +
    "                        data-qe-id=\"bm-perm-grp-members-grid-toggle-filters-panel-btn\"\n" +
    "                        tooltip-placement=\"top\"\n" +
    "                        tooltip-append-to-body=\"true\"                        \n" +
    "                        uib-tooltip=\"{{$ctrl.showGroupPanel}}\"        \n" +
    "                        tooltip-trigger=\"'focus mouseenter'\"                \n" +
    "                        aria-label=\"{{$ctrl.showGroupPanel}}\"\n" +
    "                        ng-click=\"$ctrl.toggleFilters(true);$ctrl.groupPanelHidden=!$ctrl.groupPanelHidden\"\n" +
    "                        class=\"navbar-right btn btn-default btn-icon btn-toggle\"\n" +
    "                        ng-class=\"{ active: !$ctrl.groupPanelHidden}\">\n" +
    "                        <i class=\"bento-icon-tree\"></i>\n" +
    "                    </button>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <form class=\"navbar-form navbar-right search-filter\" role=\"search\">\n" +
    "                        <div class=\"form-group filter-container\">\n" +
    "                            <label class=\"sr-only\" for=\"membersSearch\" translate=\"Bluemoon.Core.Setup.Groups.Search\"></label>\n" +
    "                            <input data-qe-id=\"bm-perm-grp-members-grid-search\" bento-reset type=\"text\" id=\"membersSearch\" class=\"form-control\" placeholder=\"{{ 'Bluemoon.Core.Setup.Groups.Search' | translate}}\" ng-model=\"$ctrl.membersFilterOptions.filterText\">\n" +
    "                        </div>\n" +
    "                    </form>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "        <bm-permission-groups-members-grid\n" +
    "            group-type=\"$ctrl.groupType\"\n" +
    "            group-name=\"$ctrl.groupName\"\n" +
    "            grid-data=\"$ctrl.filteredMembers\"\n" +
    "            columns=\"$ctrl.membersGridColumns\" \n" +
    "            filters-hidden=\"$ctrl.filtersHidden\"\n" +
    "            group-panel-hidden=\"$ctrl.groupPanelHidden\"\n" +
    "            on-selected-items-change=\"$ctrl.updateMembers($event)\">\n" +
    "        </bm-permission-groups-members-grid>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("components/permission-groups-members/export/permission-groups-staff-modal.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-members/export/permission-groups-staff-modal.html",
    "<div id=\"member-transferbox\">\n" +
    "    <button data-qe-id=\"bm-perm-grp-members-staff-cancel\" type=\"button\" class=\"close close-box\" aria-label=\"Close\" ng-click=\"ctrl.cancel()\">\n" +
    "        <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\" translate=\"Bluemoon.Core.Setup.Groups.AddModal.Heading\"></div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div bento-toolbar toolbar-data=\"ctrl.staffToolbarBtn\" class=\"navbar navbar-default bento-toolbar\" aria-controls=\"table1\">\n" +
    "            <ul class=\"nav navbar-right\" role=\"group\">\n" +
    "                <li>\n" +
    "                    <button\n" +
    "                        data-qe-id=\"bm-perm-grp-members-staff-grid-toolbar-toggle-filter-btn\"\n" +
    "                        ng-click=\"ctrl.toggleFilters()\"\n" +
    "                        class=\"navbar-right btn btn-default btn-icon btn-toggle\"\n" +
    "                        ng-class=\"{ active: !ctrl.filtersHidden}\"\n" +
    "                        ng-disabled=\"!ctrl.groupPanelHidden\">\n" +
    "                        <i class=\"bento-icon-filter-az\"></i>\n" +
    "                    </button>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <button\n" +
    "                        data-qe-id=\"bm-perm-grp-members-staff-grid-toolbar-toggle-panel-btn\"\n" +
    "                        ng-click=\"ctrl.toggleFilters(true);ctrl.groupPanelHidden=!ctrl.groupPanelHidden\"\n" +
    "                        class=\"navbar-right btn btn-default btn-icon btn-toggle\"\n" +
    "                        ng-class=\"{ active: !ctrl.groupPanelHidden}\">\n" +
    "                        <i class=\"bento-icon-tree\"></i>\n" +
    "                    </button>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <form class=\"navbar-form navbar-right search-filter\" role=\"search\">\n" +
    "                        <div class=\"form-group filter-container\">\n" +
    "                            <label class=\"sr-only\" for=\"staffSearch\" translate=\"Bluemoon.Core.Setup.Groups.Search\"></label>\n" +
    "                            <input data-qe-id=\"bm-perm-grp-members-staff-grid-toolbar-search\" bento-reset type=\"text\" id=\"staffSearch\" class=\"form-control\" placeholder=\"{{ 'Bluemoon.Core.Setup.Groups.Search' | translate}}\" ng-model=\"ctrl.staffFilterOptions.filterText\">\n" +
    "                        </div>\n" +
    "                    </form>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "        <div class=\"permission-groups-view\">\n" +
    "            <div class=\"grid-container\">\n" +
    "                <bm-permission-groups-members-grid\n" +
    "                    grid-data=\"ctrl.filteredStaff\"\n" +
    "                    columns=\"ctrl.staffGridColumns\"\n" +
    "                    filters-hidden=\"ctrl.filtersHidden\"\n" +
    "                    group-panel-hidden=\"ctrl.groupPanelHidden\"\n" +
    "                    on-selected-items-change=\"ctrl.updateMembers($event)\">\n" +
    "                </bm-permission-groups-members-grid>\n" +
    "<!--                 <wj-group-panel\n" +
    "                grid=\"ctrl.staffGridCtrl\"\n" +
    "                placeholder=\"{{ctrl.groupsPlaceholder}}\"\n" +
    "                hide-grouped-columns=\"false\"\n" +
    "                ng-if=\"!ctrl.groupPanelHidden\">\n" +
    "                </wj-group-panel>\n" +
    "                <wj-flex-grid\n" +
    "                control=\"ctrl.staffGridCtrl\"\n" +
    "                is-read-only=\"true\"\n" +
    "                class=\"bento-flex-grid\"\n" +
    "                items-source=\"ctrl.staffGridCollectionView\"\n" +
    "                sort-row-index=\"0\">\n" +
    "                    <wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "                        <div ng-if=\"$col.index === 1 && $row.index!=1\">\n" +
    "                            <i\n" +
    "                            ng-click=\"ctrl.onStaffHeaderCheckboxChange($item)\"\n" +
    "                            class=\"bento-flex-grid-checkbox\"\n" +
    "                            ng-class=\"{'bento-icon-checkmark':ctrl.allStaffSelected}\">\n" +
    "                            </i>\n" +
    "                        </div>\n" +
    "                    </wj-flex-grid-cell-template>\n" +
    "                    <wj-flex-grid-cell-template\n" +
    "                    cell-type=\"RowHeader\">\n" +
    "                        <div ng-if=\"$col.index === 0\">{{$row.index+1}}</div>\n" +
    "                        <div ng-if=\"$col.index === 1\">\n" +
    "                            <i\n" +
    "                            ng-click=\"$item.selected = !$item.selected;ctrl.onCheckboxChange($item, ctrl.selectedStaff);\"\n" +
    "                            ng-model=\"$item.selected\"\n" +
    "                            class=\"bento-flex-grid-checkbox\"\n" +
    "                            ng-class=\"{'bento-icon-checkmark':$item.selected}\">\n" +
    "                            </i>\n" +
    "                        </div>\n" +
    "                    </wj-flex-grid-cell-template>\n" +
    "                    <wj-flex-grid-cell-template\n" +
    "                    cell-type=\"GroupHeader\">\n" +
    "                        <i class=\"collapse-icon\" ng-class=\"{'bento-icon-expand':$row.isCollapsed,'bento-icon-collapse':!$row.isCollapsed}\" ng-click=\"$row.isCollapsed = !$row.isCollapsed\"></i> {{$item.name}} ({{$item.items.length}})\n" +
    "                    </wj-flex-grid-cell-template>\n" +
    "                    <wj-flex-grid-column ng-repeat=\"col in ctrl.staffGridColumns\" header=\"{{col.header}}\" width=\"{{col.width}}\" binding=\"{{col.binding}}\">\n" +
    "                    <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "                        <div ng-if=\"$row.index===0\">{{$col.header}} <i ng-class=\"{'bento-icon-chevron-down':$col.currentSort==='-', 'bento-icon-chevron-up':$col.currentSort==='+'}\"></i></div>\n" +
    "                        <div ng-if=\"ctrl.filtersHidden&&$row.index===1\">{{$col.header}} <i ng-class=\"{'bento-icon-chevron-down':$col.currentSort==='-', 'bento-icon-chevron-up':$col.currentSort==='+'}\"></i></div>\n" +
    "                        <div ng-if=\"!ctrl.filtersHidden&&$row.index===1&&col.binding==='name'\">\n" +
    "                            <input type=\"text\"\n" +
    "                            class=\"form-control\"\n" +
    "                            id=\"filter-{{$col.binding}}\"\n" +
    "                            ng-focus=\"col.focused = $event\"\n" +
    "                            ng-change=\"ctrl.updateFilter($col.binding)\"\n" +
    "                            ng-keydown=\"$event.stopPropagation()\"\n" +
    "                            ng-keypress=\"$event.stopPropagation()\"\n" +
    "                            ng-model=\"col.filterText\"\n" +
    "                            tabindex=\"0\">\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"!ctrl.filtersHidden&&$row.index===1&&col.binding==='code'\">\n" +
    "                            <input type=\"text\"\n" +
    "                            class=\"form-control\"\n" +
    "                            id=\"filter-{{$col.binding}}\"\n" +
    "                            ng-focus=\"col.focused = $event\"\n" +
    "                            ng-change=\"ctrl.updateFilter($col.binding)\"\n" +
    "                            ng-keydown=\"$event.stopPropagation()\"\n" +
    "                            ng-keypress=\"$event.stopPropagation()\"\n" +
    "                            ng-model=\"col.filterText\"\n" +
    "                            tabindex=\"0\">\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"!ctrl.filtersHidden&&$row.index===1&&col.binding==='department'\">\n" +
    "                            <input type=\"text\"\n" +
    "                            class=\"form-control\"\n" +
    "                            id=\"filter-{{$col.binding}}\"\n" +
    "                            ng-focus=\"col.focused = $event\"\n" +
    "                            ng-change=\"ctrl.updateFilter($col.binding)\"\n" +
    "                            ng-keydown=\"$event.stopPropagation()\"\n" +
    "                            ng-keypress=\"$event.stopPropagation()\"\n" +
    "                            ng-model=\"col.filterText\"\n" +
    "                            tabindex=\"0\">\n" +
    "                        </div>\n" +
    "                    </wj-flex-grid-cell-template>\n" +
    "                    </wj-flex-grid-column>\n" +
    "                </wj-flex-grid> -->\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button data-qe-id=\"bm-perm-grp-members-staff-modal-add\" class=\"btn btn-primary\" translate=\"Bluemoon.Core.Setup.Groups.AddModal.AddBtn\" ng-click=\"ctrl.addMembers()\"></button>\n" +
    "        <button data-qe-id=\"bm-perm-grp-members-staff-modal-cancel\" class=\"btn btn-default\" translate=\"Bluemoon.Core.Setup.Groups.Cancel\" ng-click=\"ctrl.cancel()\"></button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/permission-groups-members/export/remove-members-confirmation-modal.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-members/export/remove-members-confirmation-modal.html",
    "<button data-qe-id=\"bm-perm-grp-members-confirm-close\" type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\" translate=\"Bluemoon.Core.Setup.Groups.RemoveModal.Heading\"></div>\n" +
    "	<div class=\"modal-confirm-body\">\n" +
    "		<p><b>{{confirmationTranslation}}</b></p>\n" +
    "		<div translate=\"Bluemoon.Core.Setup.Groups.RemoveModal.Desc\"></div>\n" +
    "	</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button data-qe-id=\"bm-perm-grp-members-confirm-save\" class=\"btn btn-primary\" translate=\"Bluemoon.Core.Setup.Groups.RemoveModal.Save\" ng-click=\"save()\"></button>\n" +
    "    <button data-qe-id=\"bm-perm-grp-members-confirm-cancel\" class=\"btn btn-default\" translate=\"Bluemoon.Core.Setup.Groups.Cancel\" ng-click=\"cancel()\"></button>\n" +
    "</div>");
}]);

angular.module("components/permission-groups-picker/export/bm-permission-groups-picker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-picker/export/bm-permission-groups-picker.html",
    "<div id=\"bm-perm-groups-picker\" class=\"bento-container\">\n" +
    "	<div class=\"panel panel-default\">\n" +
    "		<div class=\"panel-heading\" translate=\"Bluemoon.Core.Setup.Groups.AssignedGroups\"></div>\n" +
    "		<div class=\"panel-body\">\n" +
    "			<div class=\"perm-group-list\">\n" +
    "				<div data-bmp-control-group=\"\">\n" +
    "					<p><strong>{{$ctrl.selectForStaffText}}</strong></p>\n" +
    "					<a ng-href=\"{{$ctrl.interactionHelpLink}}\" target=\"_blank\" translate=\"Bluemoon.Core.Setup.Groups.LearnMore.Interactions\"></a>\n" +
    "					<div\n" +
    "						ng-model=\"$ctrl.currSelectedGroups\"\n" +
    "						bmp-control-group-field=\"Bluemoon.Core.Setup.Groups.Title\"\n" +
    "						bmp-custom-validation-defer=\"$ctrl.mustHaveAccessToOneOrMoreGroups()\"\n" +
    "						bmp-custom-validation-message=\"Bluemoon.Core.Setup.Groups.Validation.MustSelectGroups\">\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<ul data-qe-id=\"bm-perm-grps-picker-grp-list\">\n" +
    "					<li ng-class=\"{selected: $ctrl.selectedGroup===group}\" class=\"group-container\" ng-click=\"$ctrl.selectedGroup = group\" ng-repeat=\"group in $ctrl.allGroups\">\n" +
    "						<div\n" +
    "							bento-toggle\n" +
    "							is-locked=\"(group.permissionGroupType === 'system.administrators' && $ctrl.contact.employeeCode === 'ADMIN') || $ctrl.granPermsDisabled\"\n" +
    "							ng-model=\"group.selected\"\n" +
    "							on-change=\"$ctrl.toggleGroup(group)\">\n" +
    "						</div>\n" +
    "						<div class=\"group-label\">\n" +
    "							<div class=\"name\">\n" +
    "								<p><strong>{{group.name}}</strong></p>\n" +
    "								<span class=\"label label-info\" ng-if=\"group.system\" translate=\"Bluemoon.Core.Setup.Groups.Flag.SystemGroup\"></span>\n" +
    "							</div>\n" +
    "							<p>{{group.description}}</p>\n" +
    "						</div>\n" +
    "					</li>\n" +
    "				</ul>\n" +
    "			</div>\n" +
    "			<div class=\"panel-right\">\n" +
    "				<uib-tabset class=\"tabs-top\">\n" +
    "					<uib-tab data-qe-id=\"bm-perm-grps-picker-functionality-tab\" heading=\"{{$ctrl.functionalityHeading}}\">\n" +
    "						<div>\n" +
    "							<div ng-if=\"$ctrl.selectedGroupPerms.length > 0\" bento-busy-loader=\"$ctrl.showBusyLoader\">\n" +
    "								<nucleus-permissions-form read-only=\"true\" schema=\"$ctrl.selectedGroupPerms\"></nucleus-permissions-form>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</uib-tab>\n" +
    "					<uib-tab heading=\"{{$ctrl.dataHeading}}\">\n" +
    "						<div>\n" +
    "							<div data-qe-id=\"bm-perm-grps-picker-data-tab\" ng-if=\"$ctrl.selectedGroupPerms.length > 0\" bento-busy-loader=\"$ctrl.showBusyLoader\">\n" +
    "								<bm-permission-groups-data read-only=\"true\" group-data=\"$ctrl.selectedGroupPermsData\"></bm-permission-groups-data>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</uib-tab>\n" +
    "				</uib-tabset>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/permission-groups-picker/export/permission-groups-picker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permission-groups-picker/export/permission-groups-picker.html",
    "<div bm-if-not-perm=\"Platform.GranularPermissions\">\n" +
    "	<div class=\"bento-container\">\n" +
    "		<div bento-busy-loader=\"$ctrl.showBusyLoader\">\n" +
    "			<div data-bmp-control-group=\"\" >\n" +
    "				<label class=\"strong\" translate=\"Bluemoon.Core.Setup.Groups.Title\" bm-required-mark></label>\n" +
    "				<!--translate=\"Bluemoon.Core.Setup.Groups.Validation.MustSelectGroups\"-->\n" +
    "				<div bento-multiselect-overlay\n" +
    "					 data-qe-id=\"bm-perm-grp-picker-multiselect\"\n" +
    "					 list-data=\"$ctrl.allGroups\"\n" +
    "					 ng-hide=\"$ctrl.granPermsDisabled\"\n" +
    "		         	 ng-change=\"$ctrl.onMultiselectDone($ctrl.currSelectedGroups)\"\n" +
    "			         ng-model=\"$ctrl.currSelectedGroups\"\n" +
    "			         revert-selections-on-dismissal=\"true\"\n" +
    "			         sort=\"true\"\n" +
    "					 bmp-control-group-field=\"Bluemoon.Core.Setup.Groups.Title\"\n" +
    "					 bmp-custom-validation-defer=\"$ctrl.mustHaveAccessToOneOrMoreGroups()\"\n" +
    "	                 bmp-custom-validation-message=\"Bluemoon.Core.Setup.Groups.Validation.MustSelectGroups\"\n" +
    "	                 class=\"setup-bento-multiselect-overlay\"></div>\n" +
    "			</div>\n" +
    "		  	<p class=\"well\">\n" +
    "		    	<strong translate=\"Bluemoon.Core.Setup.Groups.SelectedGroups\"></strong>\n" +
    "			    <span ng-repeat=\"item in $ctrl.currSelectedGroups\">\n" +
    "					<span class=\"label label-success\">{{item.name}}</span>\n" +
    "			   	</span>\n" +
    "			</p>\n" +
    "		</div>\n" +
    "		<div ng-show=\"$ctrl.currSelectedGroups.length !== 0\" class=\"bento-container\">\n" +
    "			<nucleus-permissions-form read-only=\"true\" schema=\"$ctrl.mergedPerms\"></nucleus-permissions-form>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<div bm-if-has-access=\"Platform_GranularPermissions\">\n" +
    "	<div bm-if-perm=\"Platform.GranularPermissions\">\n" +
    "		<bm-permission-groups-picker contact=\"$ctrl.contact\"></bm-permission-groups-picker>\n" +
    "	</div>\n" +
    "</div>");
}]);
